import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  //useMemo,
  // useCallback,
  useRef,
} from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Grid from "@mui/material/Unstable_Grid2";
import { useNavigate } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
// import DataTableBase from "../common/DataTableBase";
// import PageNavbar from "./PageNavbar";
import Toolbox from "./Toolbox";
import Typography from "@mui/material/Typography";
// import SlidingDrawer from "../common/SlidingDrawer";
// import ApproveFilingMaster from "./ApproveFilingMaster";
import _ from "lodash";
import { capitalizeLeadingText } from "../../utils/textFormat";
// import filingMasters from "../../data/filingMasters.json";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import AuthContext from "../../context/auth/AuthContext";
import { useResponsive } from "../hooks/useResponsive";
import { useCommonDetailsContext } from "../../context/Common/common";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator, FilterService } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import FilingMasterComments from "./FilingMasterComments";
import AssociatedClient from "./AssociatedClient";
// import { FilingMaster, FilingMasterComment } from "../../types/FilingMaster";
import useDialog from "../common/UseDialog";
//import ReactLoading from "react-loading";
//import { CircularProgress } from "@mui/material";
import FilingMasterAttachment from "./FilingMasterAttachment";
import FilingMasterHistory from "./FilingMasterHistory";
import * as xlsx from "xlsx";
import { saveAs } from "file-saver";
import axios from "axios";
import IconButton from "@mui/material/IconButton";
//import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import { TextField, InputAdornment, Stack } from "@mui/material";
import { TrackNowButton } from "../ui";
import FilingMasterTableFilter from "./FilingMasterTableFilter";
import { DateTime } from "luxon";
import { Calendar } from "primereact/calendar";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import CustomDialog from "../common/CustomDialog";
import { OverlayPanel } from "primereact/overlaypanel";
import states from "../../data/StateLookup.json";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import ClientFilingMasterContext from '../../context/client-filing-master/ClientFilingMasterContext';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { tokens } from "../../theme/tokens";
import usePermission from "../../usePermission";

// Table-specific compact button component

const TableCompactButton = ({ children, onClick, style = {} }) => {
  const { publishedBranding } = useCommonDetailsContext();
  const tableHeaderColor = publishedBranding?.primaryColor || tokens.colors.connectedPurple;

  const handleMouseEnter = (e) => {
    e.currentTarget.style.fontWeight = '600';
    const childDivs = e.currentTarget.querySelectorAll('div');
    childDivs.forEach(div => {
      if (!div.style.fontSize || div.style.fontSize !== '12px') {
        div.style.fontWeight = '600';
      }
    });
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.fontWeight = '400';
    const childDivs = e.currentTarget.querySelectorAll('div');
    childDivs.forEach(div => {
      if (!div.style.fontSize || div.style.fontSize !== '12px') {
        div.style.fontWeight = '400';
      }
    });
  };

  const handleMouseDown = (e) => {
    e.currentTarget.style.fontWeight = '700';
    const childDivs = e.currentTarget.querySelectorAll('div');
    childDivs.forEach(div => {
      if (!div.style.fontSize || div.style.fontSize !== '12px') {
        div.style.fontWeight = '700';
      }
    });
  };

  const handleMouseUp = (e) => {
    e.currentTarget.style.fontWeight = '600';
    const childDivs = e.currentTarget.querySelectorAll('div');
    childDivs.forEach(div => {
      if (!div.style.fontSize || div.style.fontSize !== '12px') {
        div.style.fontWeight = '600';
      }
    });
  };

  return (
    <button
      onClick={onClick}
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        color: tableHeaderColor,
        cursor: onClick ? 'pointer' : 'default',
        fontSize: '14px',
        fontWeight: 400,
        padding: '4px 8px',
        borderRadius: '4px',
        textAlign: 'left',
        width: '100%',
        transition: 'font-weight 0.2s ease',
        ...style
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      type='button'
    >
      {children}
    </button>
  );
};

const FilingNameOverflowText = ({ text, watchKey }) => {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (!text) {
      setIsOverflowing(false);
      return;
    }

    const checkOverflow = () => {
      const el = textRef.current;
      if (!el) {
        setIsOverflowing(false);
        return;
      }
      setIsOverflowing(el.scrollWidth > el.clientWidth + 1);
    };

    let frameId = window.requestAnimationFrame(checkOverflow);
    let resizeObserver = null;
    if (typeof ResizeObserver !== "undefined" && textRef.current) {
      resizeObserver = new ResizeObserver(() => checkOverflow());
      resizeObserver.observe(textRef.current);
    }
    window.addEventListener("resize", checkOverflow, { passive: true });

    return () => {
      window.cancelAnimationFrame(frameId);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      window.removeEventListener("resize", checkOverflow);
    };
  }, [text, watchKey]);

  const content = (
    <span
      ref={textRef}
      style={{
        display: "inline-block",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        verticalAlign: "bottom",
      }}
    >
      {text}
    </span>
  );

  if (!text) {
    return <span />;
  }

  return isOverflowing ? (
    <Tooltip title={text} arrow>
      <span style={{ display: "inline-block", maxWidth: "100%" }}>{content}</span>
    </Tooltip>
  ) : (
    content
  );
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const FilingMasterList = () => {
  const { publishedBranding } = useCommonDetailsContext();
  const tableHeaderColor = publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const primaryColor = tableHeaderColor;
  const { isMobile, mdUp } = useResponsive();
  const enableForzen = !isMobile
  const [selectedRows, setSelectedRows] = useState([]);
  const [jurisdiction, setJurisdiction] = useState([]);
  const [federalCategoriesLookup, setFederalCategoriesLookup] = useState([]);
  const [stateCategoriesLookup, setStateCategoriesLookup] = useState([]);
  const [categoriesLookup, setCategoriesLookup] = useState([]);
  //const [stateLookup, setStateLookup] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [downloadStatusMsg, setDownloadStatusMsg] = useState("");
  const [showDownloadProgress, setShowDownloadProgress] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    header: "Information",
    icon: "\u2139\uFE0F",
  });
  const [refreshOnAlertClose, setRefreshOnAlertClose] = useState(false);
  const [selectedmasters, setSelectedMasters] = useState(null);
  let [masters, setMasters] = useState([]);
  const [sortMaster, setSortMaster] = useState([]);
  const [sortRecord, setSortRecord] = useState("Upcoming Due Dates");
  const [comments, setComments] = React.useState([]);
  const [clients, setClients] = React.useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState('');
  const [currentYearVal, setCurrentYearVal] = useState("")
  const [yearsList, setYearsList] = useState([]);
  // const [filingMasterList, setFilingMasterList] = useState([]);
  const [value, setValue] = React.useState('1');
  const [isDisabled, setIsDisabled] = useState(false);
  const dataTableRef = useRef(null);
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const [isClearIcon, setIsClearIcon] = useState(false);
  const [categoryList, setCategoryList] = useState([])
  const [activeFilters, setActiveFilters] = useState([]);
  const [activeFiltersByTab, setActiveFiltersByTab] = useState({ '1': [], '2': [] });
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  const [lazyLoading, setLazyLoading] = useState(false);
  const [refreshRecordList, setRefreshRecordList] = useState(false);
  const [refreshDetails, setRefreshDetails] = useState(null);
  const [recordsInView, setRecordsInView] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFilterChange, setIsFilterChange] = useState([]);
  const [filterChangesByTab, setFilterChangesByTab] = useState({ '1': [], '2': [] });
  const [sortingData, setSortingData] = useState({
    sortBy: "",
    sortOrder: "",
  });
  const [upcomingDueDateVal, setupcomingDueDateVal] = useState("");
  const [isFrozenColumnsCondensed, setIsFrozenColumnsCondensed] = useState(false);
  const lazyLoadInFlightRef = useRef(false);
  const programmaticScrollMuteUntilRef = useRef(0);
  const frozenColumnsCondensedRef = useRef(false);
  const recordsRequestIdRef = useRef(0);
  const mastersRef = useRef([]);
  const recordsInViewRef = useRef(0);
  const overlayRefs = useRef({});
  const setRecordsInViewSafe = (nextValue) => {
    setRecordsInView((old) => {
      const next = typeof nextValue === "function" ? nextValue(old) : nextValue;
      recordsInViewRef.current = next;
      return next;
    });
  };
  const setMastersSafe = (nextValue) => {
    setMasters((old) => {
      const next = typeof nextValue === "function" ? nextValue(old) : nextValue;
      mastersRef.current = next;
      return next;
    });
  };

  const setTabActiveFilters = (tabValue, nextFilters) => {
    setActiveFilters(nextFilters);
    setActiveFiltersByTab((prev) => ({
      ...prev,
      [tabValue]: nextFilters,
    }));
  };

  const setTabFilterChanges = (tabValue, nextFilterChanges) => {
    setIsFilterChange(nextFilterChanges);
    setFilterChangesByTab((prev) => ({
      ...prev,
      [tabValue]: nextFilterChanges,
    }));
  };


  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    filingId: { value: null, matchMode: FilterMatchMode.IN },
    // filingName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    filingDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // filingFrequency: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // dueDayofFrequency: { value: null, matchMode: FilterMatchMode.IN },
    // stateInfo: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // stateList: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // ruleInfo: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // required: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // federalCategories: { value: null, matchMode: FilterMatchMode.IN },
    // stateCategories: { value: null, matchMode: FilterMatchMode.IN },
    jsidept: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //jsicontactName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    jsicontactEmail: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // juristiction: { value: null, matchMode: FilterMatchMode.IN },
    // whereToFile: { value: null, matchMode: FilterMatchMode.CONTAINS },
    filingName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    filingFrequency: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    stateList: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    ruleInfo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    required: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    federalCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    stateCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    jsicontactName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    juristiction: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    whereToFile: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    dueDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
  });
  const [stateArray, setStateArray] = useState([]);
  const [showAttachments, setShowAttachments] = useState(false);
  const [attachments, setAttachments] = React.useState([]);

  const [showHistory, setShowHistory] = useState(false);
  const [activityHistory, setActivityHistory] = React.useState([]);
  const [commentActivityHistory, setCommentActivityHistory] = React.useState([]);
  const [expandedRows, setExpandedRows] = useState(null);

  const filingMasterContext = useContext(FilingMasterContext);
  const {
    setCurrentFilingMaster,
    getFilingMasters,
    setFilingMasters,
    filingMasters,
    filingMasterLoaded,
    getFilingMasterComments,
    deleteDraftFilingMaster,
    createFilingMasterWorkflow,
    getBusinessCategories,
  } = filingMasterContext;
  const {
    fetchConfigurations,
  } = clientFilingMasterContext;
  // const [visibleApps, setVisibleApps] = useState(props.projects);
  const [showComments, setShowComments] = useState(false);
  const [showClient, setShowClient] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [masterCatFilter, setMasterCatFilter] = useState([]);
  const [upcomingCatFilter, setUpcomingCatFilter] = useState([]);
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { authUser, userRoles } = authContext;
  const backToHome = () => {
    navigate("/");
  };

  FilterService.register("customFilter_not", (item, filterBy) => {
    // console.log("customFilter_not", item, filterBy);
    return item !== undefined && !item?.includes(filterBy);
  });

  const fetchFilingMasterComments = async (filingId) => {
    // console.log("@@Fetch FilingMasters1:", getFilingMasterComments);
    if (getFilingMasterComments) {
      // console.log("@@Fetch FilingMasters2:");
      try {
        const commentList = await getFilingMasterComments(filingId);
        setComments(() => commentList);
        // console.log("@@Fetch FilingMasters2 comments:", commentList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };
  const fetchConfigs = async () => {
    if (fetchConfigurations) {
      let config = await fetchConfigurations();
      console.log("loadRecordsList config", config)
      let startYear = config.find(
        (ele) => ele.configItem === 'StartYear'
      ).configItemValue;
      let currentYear = config.find(
        (ele) => ele.configItem === 'CurrentYear'
      ).configItemValue;
      startYear = parseInt(startYear);
      currentYear = parseInt(currentYear);
      console.log("loadRecordsList currentYear", currentYear)
      const yearsInBetween = [];
      for (let year = startYear; year < currentYear; year++) {
        yearsInBetween.push(year);
      }
      setYearsList(yearsInBetween);
      setSelectedYear(currentYear - 1);
      setCurrentYearVal(currentYear)
      setLazyLoading(false)
      return
    }
  };
  const addComment = (rowData) => {
    // console.log("Display Comments", selectedmasters);
    // console.log("Fetching Comments", rowData);
    // if (filingId) {
    //   console.log(`Fetching Commnet for :${filingId}`);
    //   fetchFilingMasterComments(filingId);

    //   setShowComments(() => true);
    // }
    if (rowData && rowData.filingId) {
      // console.log(`Fetching Commnet for :${rowData.filingId}`);
      fetchFilingMasterComments(rowData.filingId);
      setShowComments(() => true);
      setSelectedMasters(rowData);
    } else if (selectedmasters && selectedmasters.filingId) {
      // console.log(`Fetching Commnet for :${selectedmasters.filingId}`);
      fetchFilingMasterComments(selectedmasters.filingId);
      setShowComments(() => true);
    } else {
      showSelectionRequiredPopup();
      closeDialog();
    }
  };

  const displayClients = () => {
    // console.log("Display clients", selectedmasters);
    if (selectedmasters && selectedmasters.filingId) {
      // console.log(`Fetching clients for :${selectedmasters.filingId}`);
      // fetchFilingMasterClients(selectedmasters.filingId);
      fetchFilingMasterClients(selectedmasters.filingId);
      setShowClient(() => true);
    } else {
      showSelectionRequiredPopup();
      closeDialog();
    }
  };
  const getStateName = (stateCode) => {
    const state = states.find((s) => s.code === stateCode);
    const stateName = state ? state.state : stateCode;
    return stateName;
  };
  const fetchMasterActive = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterList?RecordType=TrackNow`
      );
      console.log("fetchMasterActive res", res);
      return res.data; // Assuming the response contains the data you need
    } catch (error) {
      console.error("Error fetching tracker data:", error);
      throw error; // Propagate the error
    }
  };
  const fetchMasterHistory = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterList?RecordType=TrackNow&Year=${selectedYear}`
      );
      // console.log("fetchMasterHistory res", res);
      return res.data; // Assuming the response contains the data you need
    } catch (error) {
      console.error("Error fetching tracker data:", error);
      throw error; // Propagate the error
    }
  };

  const exportExcel = async () => {
    if (showDownloadProgress) return;
    setShowDownloadProgress(true);
    setDownloadProgress(10);
    setDownloadStatusMsg("Fetching filing master records from server...");

    let currentProgress = 10;
    const progressTimer = setInterval(() => {
      if (currentProgress < 85) {
        currentProgress += Math.floor(Math.random() * 5) + 3;
        if (currentProgress > 85) currentProgress = 85;
        setDownloadProgress(currentProgress);
        setDownloadStatusMsg(`Fetching filing master records from server (${currentProgress}%)...`);
      }
    }, 750);

    try {
      const resList = await fetchMasterActive();
      clearInterval(progressTimer);

      if (!resList || resList.length === 0) {
        setShowDownloadProgress(false);
        setDownloadProgress(0);
        showInfoPopup("No data to download", true);
        return;
      }

      setDownloadProgress(92);
      setDownloadStatusMsg(`Formatting ${resList.length.toLocaleString()} master records...`);

      setTimeout(() => {
        const updData = resList.flatMap((item) => {
          if (item.formattedDueDates && item.formattedDueDates !== "") {
            const dueDatesArray = item.formattedDueDates.split(',');
            return dueDatesArray.map((date) => ({
              ...item,
              individualDueDate: date.trim(),
            }));
          } else {
            return [{ ...item, individualDueDate: "" }];
          }
        });

        const renamedData = updData.map((item) => {
          const stateMod = getStateName(item.stateInfo)
          const dueDateMod = item.dueDate ? formatDateSheet(item.dueDate) : "";
          let whoMustFileFederalMod = '';
          let whoMustFileinStateMod = '';

          if (item.juristiction === "Federal") {
            whoMustFileFederalMod = item.businessCategory ? item.businessCategory.map(obj => obj.businessCategoryName).join(', ') : '';
          } else if (item.juristiction === "State") {
            const filteredCategories = item.businessCategory ? item.businessCategory.filter(category => category.state === item.stateInfo) : [];
            whoMustFileinStateMod = filteredCategories.map(obj => obj.businessCategoryName).join(', ');
          }

          return {
            "Filing Name": item.filingName,
            "Filing Frequency ": item.filingFrequency,
            "State ": stateMod,
            "Rule Info": item.ruleInfo,
            "Required ": item.required,
            "Due Dates": dueDateMod,
            "Who Must File Federal": whoMustFileFederalMod,
            "Who Must File in state": whoMustFileinStateMod,
            "JSI Staff": item.jsicontactName,
            "Jurisdiction ": item.juristiction,
            "Where to File": item.whereToFile,
            "RecordType": item.recordType,
            "Notes": item.notes,
          };
        });

        const worksheet = xlsx.utils.json_to_sheet(renamedData);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
          compression: false,
        });

        setDownloadProgress(100);
        setDownloadStatusMsg("Download complete!");
        saveAsExcelFile(excelBuffer, "filingmaster");

        setTimeout(() => {
          setShowDownloadProgress(false);
          setDownloadProgress(0);
          setDownloadStatusMsg("");
        }, 400);
      }, 10);
    } catch (error) {
      clearInterval(progressTimer);
      console.log("error", error);
      setShowDownloadProgress(false);
      setDownloadProgress(0);
    }
  };

  const saveAsExcelFile = (buffer, fileName) => {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data = new Blob([buffer], {
      type: EXCEL_TYPE,
    });

    saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  };

  const exportExcelHistory = async () => {
    if (showDownloadProgress) return;
    setShowDownloadProgress(true);
    setDownloadProgress(10);
    setDownloadStatusMsg("Fetching history records from server...");

    let currentProgress = 10;
    const progressTimer = setInterval(() => {
      if (currentProgress < 85) {
        currentProgress += Math.floor(Math.random() * 5) + 3;
        if (currentProgress > 85) currentProgress = 85;
        setDownloadProgress(currentProgress);
        setDownloadStatusMsg(`Fetching history records from server (${currentProgress}%)...`);
      }
    }, 750);

    try {
      const resList = await fetchMasterHistory();
      clearInterval(progressTimer);

      if (!resList || resList.length === 0) {
        setShowDownloadProgress(false);
        setDownloadProgress(0);
        showInfoPopup("No data to download", true);
        return;
      }

      setDownloadProgress(92);
      setDownloadStatusMsg(`Formatting ${resList.length.toLocaleString()} history records...`);

      setTimeout(() => {
        const updData = resList.flatMap((item) => {
          if (item.formattedDueDates && item.formattedDueDates !== "") {
            const dueDatesArray = item.formattedDueDates.split(',');
            return dueDatesArray.map((date) => ({
              ...item,
              individualDueDate: date.trim(),
            }));
          } else {
            return [{ ...item, individualDueDate: "" }];
          }
        });

        const renamedData = updData.map((item) => {
          const stateMod = getStateName(item.stateInfo)
          const dueDateMod = item.dueDate ? formatDateSheet(item.dueDate) : "";
          let whoMustFileFederalMod = '';
          let whoMustFileinStateMod = '';

          if (item.juristiction === "Federal") {
            whoMustFileFederalMod = item.businessCategory ? item.businessCategory.map(obj => obj.businessCategoryName).join(', ') : '';
          } else if (item.juristiction === "State") {
            const filteredCategories = item.businessCategory ? item.businessCategory.filter(category => category.state === item.stateInfo) : [];
            whoMustFileinStateMod = filteredCategories.map(obj => obj.businessCategoryName).join(', ');
          }

          return {
            "Filing Name": item.filingName,
            "Filing Frequency ": item.filingFrequency,
            "State ": stateMod,
            "Rule Info": item.ruleInfo,
            "Required ": item.required,
            "Due Dates": dueDateMod,
            "Who Must File Federal": whoMustFileFederalMod,
            "Who Must File in state": whoMustFileinStateMod,
            "JSI Staff": item.jsicontactName,
            "Jurisdiction ": item.juristiction,
            "Where to File": item.whereToFile,
            "RecordType": item.recordType,
            "Notes": item.notes,
          };
        });

        const worksheet = xlsx.utils.json_to_sheet(renamedData);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
          compression: false,
        });

        setDownloadProgress(100);
        setDownloadStatusMsg("Download complete!");
        saveAsExcelFileHistory(excelBuffer, "filingmaster");

        setTimeout(() => {
          setShowDownloadProgress(false);
          setDownloadProgress(0);
          setDownloadStatusMsg("");
        }, 400);
      }, 10);
    } catch (error) {
      clearInterval(progressTimer);
      console.log("error", error);
      setShowDownloadProgress(false);
      setDownloadProgress(0);
    }
  };

  const saveAsExcelFileHistory = (buffer, fileName) => {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data = new Blob([buffer], {
      type: EXCEL_TYPE,
    });

    saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  };
  const openAlertDialog = ({
    message,
    header = "Information",
    icon,
    refreshOnClose = false,
  }) => {
    setAlertConfig({ header, icon });
    setAlertMessage(message);
    setRefreshOnAlertClose(refreshOnClose);
    setShowAlert(true);
  };

  const showSelectionRequiredPopup = (
    message = "Please Select a Master Record"
  ) => {
    openAlertDialog({
      message,
      header: "Selection Required",
      icon: "\u26A0\uFE0F",
    });
  };

  const showInfoPopup = (message, refreshOnClose = false) => {
    openAlertDialog({
      message,
      header: "Information",
      icon: "\u2139\uFE0F",
      refreshOnClose,
    });
  };

  const showSuccessPopup = (message, refreshOnClose = false) => {
    openAlertDialog({
      message,
      header: "Success",
      refreshOnClose,
    });
  };

  const showErrorPopup = (message, refreshOnClose = false) => {
    openAlertDialog({
      message,
      header: "Error",
      icon: "\u274C",
      refreshOnClose,
    });
  };

  const closeAlert = () => {
    setShowAlert(false);
    if (refreshOnAlertClose) {
      setRefreshRecordList(true);
    }
    setRefreshOnAlertClose(false);
  };

  const fetchFilingMasterAttachments = async (filingId) => {
    // console.log("fetchFilingMasterAttachments props", filingId);
    try {
      const attachmentList = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterAttachments/${filingId}`
      );
      setAttachments(() => attachmentList.data.data);
      // console.log("fetchFilingMasterAttachments res", attachmentList);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };
  const fetchFilingMasterClients = async (filingId) => {
    // console.log("fetchFilingMasterClients props", filingId);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterList${filingId}`
      );
      const clientsData = response.data;
      // console.log("Customer", clientsData);
      const customerArray = clientsData.customer;
      setClients(customerArray);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };
  // console.log("CLIENTSDATA", clients);
  const displayAttachments = async (rowData) => {
    // console.log("displayAttachments", selectedmasters);
    // console.log("displayAttachments", rowData);
    if (rowData && rowData.filingId) {
      // console.log(`Fetching Attachment for :${rowData.filingId}`);
      fetchFilingMasterAttachments(rowData.filingId);
      setShowAttachments(() => true);
      setSelectedMasters(rowData);
    } else if (selectedmasters && selectedmasters.filingId) {
      // console.log(`Fetching Attachment for :${selectedmasters.filingId}`);
      fetchFilingMasterAttachments(selectedmasters.filingId);
      setShowAttachments(() => true);
    } else {
      showSelectionRequiredPopup();
      closeDialog();
    }
  };

  const fetchFilingMasterHistory = async (filingId) => {
    // console.log("fetchFilingMasterHistory props", filingId);
    try {
      let res = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterAudit?FilingId=${filingId}`
      );
      let history = res.data.data;
      // console.log("fetchFilingMasterHistory props", res.data.data, history);
      setActivityHistory(() => history);
      // console.log("fetchFilingMasterHistory res", history);
    } catch (error) {
      console.log("@@Error:", error);
    }

    try {
      const history = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterCommentsAudit?FilingId=${filingId}`
      );
      setCommentActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const displayHistory = async () => {
    // console.log("displayHistory", selectedmasters);
    if (selectedmasters && selectedmasters.filingId) {
      // console.log(`Fetching History for :${selectedmasters.filingId}`);
      fetchFilingMasterHistory(selectedmasters.filingId);
      setShowHistory(() => true);
    } else {
      showSelectionRequiredPopup();
      closeDialog();
    }
  };

  const closeComments = () => {
    // console.log("Toggling Show Filter", showComments);
    setShowComments(() => false);
  };
  const closeClient = () => {
    // console.log("Toggling Show Filter", showClient);
    setShowClient(() => false);
  };

  const closeAttachments = () => {
    // console.log("Toggling Show Filter", showAttachments);
    setShowAttachments(() => false);
  };

  const closeHistory = () => {
    // console.log("Toggling Show Filter", showHistory);
    setSelectedMasters(null)
    setShowHistory(() => false);
  };


  const handleTabChange = (event, newValue) => {
    setMasterCatFilter([]);
    setSelectedMasters(null)
    setMastersSafe([]);
    setIsLoading(true);
    setGlobalFilterValue('');
    setupcomingDueDateVal("")
    setFilters({
      ...filters,
      global: {
        ...filters.global,
        value: null,
      },
    });
    console.log("tracktab", newValue);
    setValue(newValue);
    if (newValue === '2') {
      setIsDisabled(true);
    } else {
      setSelectedYear(currentYearVal - 1)
      setIsDisabled(false);
    }
  };

  const handleSubmit = () => {
    // console.log("Submitting Delete....", selectedmasters);
    // deleteCategory();
    deleteMasterRecord();
  };

  const closeConfirm = () => {
    // console.log("Cancelling....");
    // setSelectedRowForDelete(null);
    // navigate("/");
  };

  const {
    AlertDialog: ConfirmDialog,
    showDialog,
    closeDialog,
  } = useDialog({
    onSubmit: handleSubmit,
    onClose: closeConfirm,
    confirmVariant: "destructive",
    cancelVariant: "tertiary",
  });


  const handleDelete = () => {
    if (!selectedmasters || !selectedmasters.filingId) {
      showSelectionRequiredPopup();
      return;
    }

    showDialog(
      "Confirmation",
      <Typography>
        Are you sure you want to delete this{" "}
        <Typography fontWeight="bold" component="span">
          {selectedmasters.filingName}
        </Typography>{" "}
        record?{" "}
      </Typography>,
      "confirm"
    );
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;
    // console.log("_filters", _filters);
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const jusrisdictionItemTemplate = (option) => {
    // console.log("##TOptions:", option);
    return (
      <div className='flex align-items-center'>
        <span>{option}</span>
      </div>
    );
  };

  const requiredArray = ["True", "False"];

  const requiredRowFilterTemplate = (options) => {
    // console.log("requiredRowFilterTemplate:", options,masterCatFilter);
    if (!masterCatFilter.required && options.filterModel.value) {
      // console.log("requiredRowFilterTemplate filterModel",options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }
    return (
      <Dropdown
        value={masterCatFilter.required || []}
        options={requiredArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          ;
          setMasterCatFilter((prev) => {
            return { ...prev, required: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const upcommingRequiredRowFilterTemplate = (options) => {
    // console.log("upcommingRequiredRowFilterTemplate:", options,upcomingCatFilter);

    if (!upcomingCatFilter.required && options.filterModel.value) {
      // console.log(
      //   "upcommingRequiredRowFilterTemplate optionsfilterModel",
      //   options.filterModel
      // );
      options.filterModel.value = null;
      options.value = null;
    }
    return (
      <Dropdown
        value={upcomingCatFilter.required || []}
        options={requiredArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setUpcomingCatFilter((prev) => {
            return { ...prev, required: e.value };
          });
          options.filterCallback(e.value, options.index);
          // options.filterCallback(e.value, 'contains');
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const jusrisdictionArray = ["Federal", "State"];

  const jurisdictionRowFilterTemplate = (options) => {
    // console.log("jurisdictionRowFilterTemplate props", options,masterCatFilter);

    if (!masterCatFilter.jurisdiction && options.filterModel.value) {
      // console.log(" optionsfilterModel", options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <Dropdown
        value={masterCatFilter.jurisdiction || []}
        options={jusrisdictionArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setMasterCatFilter((prev) => {
            return { ...prev, jurisdiction: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
    // options.filterModel.matchMode === 'in' ? (
    //   <MultiSelect
    //     value={masterCatFilter.jurisdiction || []}
    //     options={jurisdiction}
    //     itemTemplate={jusrisdictionItemTemplate}
    //     onChange={(e) => {
    //       console.log('##EOptions:', e);

    //       setMasterCatFilter((prev) => {
    //         return { ...prev, jurisdiction: e.value };
    //       });
    //       options.filterApplyCallback(e.value);
    //     }}
    //     placeholder='Any'
    //     maxSelectedLabels={1}
    //     className='p-column-filter'
    //     style={{ minWidth: '14rem', maxWidth: '14rem' }}
    //   />
    // ) : (

    // );
  };

  const upcomingJurisdictionRowFilterTemplate = (options) => {
    // console.log("upcomingJurisdictionRowFilterTemplate", options , upcomingCatFilter);

    if (!upcomingCatFilter.jurisdiction && options.filterModel.value) {
      // console.log(" optionsfilterModel", options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <Dropdown
        value={upcomingCatFilter.jurisdiction || []}
        options={jusrisdictionArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setUpcomingCatFilter((prev) => {
            return { ...prev, jurisdiction: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
    //  options.filterModel.matchMode === 'in' ? (
    //     <MultiSelect
    //       value={upcomingCatFilter.jurisdiction || []}
    //       options={jurisdiction}
    //       itemTemplate={jusrisdictionItemTemplate}
    //       onChange={(e) => {
    //         console.log('##EOptions:', e);
    //         setUpcomingCatFilter((prev) => {
    //           return { ...prev, jurisdiction: e.value };
    //         });
    //         options.filterApplyCallback(e.value);
    //       }}
    //       placeholder='Any'
    //       maxSelectedLabels={1}
    //       className='p-column-filter'
    //       style={{ minWidth: '14rem', maxWidth: '14rem' }}
    //     />
    //   ) : (

    //   );
  };

  // const customCategoryFilter = (value, filter) => {
  //   console.log("##Filter value:", value);
  //   console.log("##Filter filter:", filter);
  //   filter.filterApplyCallback(value);
  //   // return value.some((cateogory) => cateogory.includes(filter)); // check if at least one skill matches filter
  // };

  const hideOtherCellOverlays = (currentKey) => {
    Object.entries(overlayRefs.current).forEach(([key, overlay]) => {
      if (key !== currentKey && overlay?.hide) {
        overlay.hide();
      }
    });
  };

  const getPreferredOverlayDirection = (cellElement) => {
    const rowElement = cellElement?.closest("tr");
    const rowIndexAttr = rowElement?.getAttribute("data-p-index");
    const rowIndex = rowIndexAttr !== null ? Number(rowIndexAttr) : -1;
    if (rowIndex >= 0 && rowIndex <= 2) {
      return "down";
    }

    const cellRect = cellElement?.getBoundingClientRect();
    if (!cellRect) {
      return "down";
    }

    return cellRect.bottom > window.innerHeight * 0.7 ? "up" : "down";
  };

  const positionOverlayNearCell = (overlayKey, cellElement, preferredDirection) => {
    const overlayPanel = overlayRefs.current[overlayKey];
    const overlayElement = overlayPanel?.container;

    if (!overlayElement || !cellElement || overlayElement.style.display === "none") {
      return;
    }

    const cellRect = cellElement.getBoundingClientRect();
    const overlayRect = overlayElement.getBoundingClientRect();
    const gap = 8;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const canOpenDown = cellRect.bottom + overlayRect.height + gap <= viewportHeight;
    const canOpenUp = cellRect.top - overlayRect.height - gap >= gap;

    let openUp = false;
    if (preferredDirection === "up" && canOpenUp) {
      openUp = true;
    } else if (preferredDirection === "down" && !canOpenDown && canOpenUp) {
      openUp = true;
    } else if (!canOpenDown && canOpenUp) {
      openUp = true;
    }

    let top = openUp
      ? cellRect.top - overlayRect.height - gap
      : cellRect.bottom + gap;
    let left = cellRect.left + cellRect.width / 2 - overlayRect.width / 2;

    left = Math.min(Math.max(left, gap), viewportWidth - overlayRect.width - gap);
    top = Math.min(Math.max(top, gap), viewportHeight - overlayRect.height - gap);

    overlayElement.style.position = "fixed";
    overlayElement.style.left = `${Math.round(left)}px`;
    overlayElement.style.top = `${Math.round(top)}px`;
    overlayElement.style.transform = "none";
  };

  const toggleCellOverlay = (event, overlayKey) => {
    event.stopPropagation();
    event.preventDefault();

    const targetElement = event.currentTarget;
    const overlayPanel = overlayRefs.current[overlayKey];
    if (!overlayPanel?.toggle) return;

    const overlayElement = overlayPanel.container;
    const isVisible = Boolean(
      overlayElement && overlayElement.style.display !== "none"
    );

    if (!isVisible) {
      hideOtherCellOverlays(overlayKey);
    }

    overlayPanel.toggle(event);

    requestAnimationFrame(() => {
      const preferredDirection = getPreferredOverlayDirection(targetElement);
      positionOverlayNearCell(overlayKey, targetElement, preferredDirection);
    });
  };

  const CellListDisplayFederal = (rowData, field) => {
    // console.log("CellListDisplayFederal", field, rowData);

    let categories = rowData[field]
      ? field === "federalCategories"
        ? rowData.businessCategory?.map((ele) => ele.businessCategoryName) || []
        : rowData.businessCategory
          ?.filter((ele) => ele.state === rowData.stateInfo)
          .map((ele) => ele.businessCategoryName) || []
      : [];
    categories = categories.filter(Boolean);

    // fallback for rows where categories are already flattened into a string field
    if (categories.length === 0 && rowData[field]) {
      categories = String(rowData[field])
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    }

    const hasValue = categories.length > 0;
    const hasMore = categories.length > 1;
    const primaryCategory = categories[0] || "";
    const remainingCount = Math.max(categories.length - 1, 0);

    let name =
      field === "federalCategories"
        ? "Who Must File Federal"
        : "Who Must File in State";
    const overlayKey = `${field}-${rowData.masterId || rowData.filingId || rowData.fileTrackingId}`;

    return (
      <div
        className='tableBtn'
        id={`${field}+${rowData.fileTrackingId}`}
        style={{
          width: "inherit",
        }}
      >
        <button
          type='button'
          onClick={(event) => {
            if (!hasValue) return;
            toggleCellOverlay(event, overlayKey);
          }}
          style={{
            background: "transparent",
            border: "none",
            cursor: hasValue ? "pointer" : "default",
            width: "100%",
            padding: 0,
            textAlign: "left",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: "inherit",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: primaryColor,
            }}
          >
            {primaryCategory}
            {hasMore && (
              <span
                className="tracker-more-count"
                style={{
                  fontSize: "12px",
                  marginLeft: "6px",
                  color: primaryColor,
                }}
              >
                {`+${remainingCount} more`}
              </span>
            )}
          </div>
        </button>
        {hasValue && (
          <OverlayPanel
            ref={(el) => {
              if (el) {
                overlayRefs.current[overlayKey] = el;
              }
            }}
            className='filing-master-overlay-panel'
            showCloseIcon
            dismissable
            style={{
              padding: "0.4rem 0.8rem",
              width: "min(22rem, calc(100vw - 1rem))",
              maxWidth: "min(22rem, calc(100vw - 1rem))",
              maxHeight: "min(18rem, calc(100vh - 1rem))",
            }}
          >
            {name}
            <div className="filing-master-overlay-scroll overlay-scroll-consistent" style={{ width: "100%", maxWidth: "100%", maxHeight: "10.5rem", overflowY: "auto", overflowX: "hidden", paddingRight: "0.25rem", boxSizing: "border-box" }}>
              <ul style={{ paddingLeft: "20px", margin: 0 }}>
                {categories.map((ele, idx) => (
                  <li key={`${field}-${rowData.masterId || rowData.filingId}-${idx}`} style={{ marginBottom: "4px" }}>
                    {ele}
                  </li>
                ))}
              </ul>
            </div>
          </OverlayPanel>
        )}
      </div>
    );
  };

  const cellListDisplayName = (rowData) => {
    const fullFilingName = rowData.filingName || "";

    return (
      <TableCompactButton style={{ fontSize: "15px", padding: "4px 8px", fontWeight: "normal" }}>
        <FilingNameOverflowText
          text={fullFilingName}
          watchKey={isFrozenColumnsCondensed}
        />
      </TableCompactButton>
    );
  };

  const cellListDisplayRuleInfo = (rowData) => {
    const ruleInfoValue = capitalizeLeadingText(rowData.ruleInfo);
    return (
      <LightTooltip title={ruleInfoValue}>
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {ruleInfoValue}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayNotes = (rowData) => {
    const notesUrl = rowData.notes;
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    if (!notesUrl) return null;

    const formattedText = notesUrl.replace(
      urlRegex,
      '<a style="color:#0000FF;" href="$&" target="_blank" rel="noopener noreferrer">$&</a>'
    );

    return (
      <LightTooltip
        arrow
        title={
          <div
            style={{
              maxWidth: "350px",
              maxHeight: "250px",
              overflowY: "auto",
              overflowX: "hidden",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowWrap: "anywhere",
              padding: "4px",// Added top/bottom & left/right padding
              fontWeight: "normal",   // Remove bold
              lineHeight: "1.5",      // Better readability
              fontSize: "14px",
            }}
            dangerouslySetInnerHTML={{ __html: formattedText }}
          />
        }
      >
        <div
          style={{
            width: "100%",
            maxWidth: "44rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          dangerouslySetInnerHTML={{ __html: formattedText }}
        />
      </LightTooltip>
    );
  };

  const cellListDisplayWhereToFile = (rowData) => {
    const value = rowData.whereToFile?.trim();
    const urlRegex = /(https?:\/\/[^\s]+)/gi;
    const urlTestRegex = /(https?:\/\/[^\s]+)/i;

    if (!value) return value;

    const parts = value.split(urlRegex);

    return (
      <LightTooltip
        title={
          <>
            {parts.map((part, index) =>
              urlTestRegex.test(part) ? (
                <a key={index} href={part} target="_blank" rel="noopener noreferrer">
                  {part}
                </a>
              ) : (
                part
              )
            )}
          </>
        }
      >
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {parts.map((part, index) =>
            urlTestRegex.test(part) ? (
              <a key={index} href={part} target="_blank" rel="noopener noreferrer">
                {part}
              </a>
            ) : (
              part
            )
          )}
        </div>
      </LightTooltip>
    );
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#F1F2F6",
      color: "black",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }));

  const cellListDisplayState = (rowData) => {
    return rowData["stateCategories"]?.join(", ");
  };

  const formatDate = (value) => {
    return value !== null && value !== ''
      ? value.toLocaleDateString('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
      : null;
  };
  const formatDateSheet = (dateString) => {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };
  const cellListDisplayDueDate = (rowData) => {
    if (rowData.dueDate) {
      return formatDate(rowData.dueDate);
    }
  };

  const masterCategoryFilter = (options, field) => {
    // console.log("OPTIONCHECK", options, "field", field);

    // let optionsList = [];
    // masters
    //   .map((item) => item?.[field])
    //   .filter(Boolean)
    //   .map((item) => {
    //     if (item.includes(",")) {
    //       // console.log("spliited_item", item);
    //       item.split(",").map((subItem) => {
    //         optionsList.push(subItem && subItem.trim());
    //       });
    //     } else {
    //       optionsList.push(item.trim());
    //     }
    //   });
    // optionsList = optionsList
    //   .filter((item, i) => {
    //     return i === optionsList.lastIndexOf(item);
    //   })
    //   .sort();

    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={masterCatFilter[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          // let values = [];
          // console.log(
          //   '##federalFilterElement#:',
          //   options.filterModel.matchMode
          // );
          // masters.forEach((item) => {
          //   if (e.value.some((category) => item[field]?.includes(category))) {
          //     values.push(item[field]);
          //   }
          // });
          // values = values.filter((item, i) => {
          //   return i === values.lastIndexOf(item);
          // });
          // console.log(e.value, 'federalFilterElement', values, options);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];
          // console.log(
          //   "##federalFilterElement#:",
          //   options.filterModel.matchMode
          // );
          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          // console.log("federalFilterElement", e.value, values);
          options.filterCallback(values, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const upcomingCategoryFilter = (options, field) => {
    // console.log("OPTIONCHECK", options, "field", field);

    // let optionsList = [];
    // masters
    //   .map((item) => item?.[field])
    //   .filter(Boolean)
    //   .map((item) => {
    //     if (item.includes(",")) {
    //       //console.log("spliited_item", item);
    //       item.split(",").map((subItem) => {
    //         optionsList.push(subItem && subItem.trim());
    //       });
    //     } else {
    //       optionsList.push(item.trim());
    //     }
    //   });
    // optionsList = optionsList
    //   .filter((item, i) => {
    //     return i === optionsList.lastIndexOf(item);
    //   })
    //   .sort();

    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={upcomingCatFilter[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, masters);
          setUpcomingCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          // let values = [];
          // console.log(
          //   '##federalFilterElement#:',
          //   options.filterModel.matchMode
          // );
          // masters.forEach((item) => {
          //   if (e.value.some((category) => item[field]?.includes(category))) {
          //     values.push(item[field]);
          //   }
          // });
          // values = values.filter((item, i) => {
          //   return i === values.lastIndexOf(item);
          // });
          // console.log(e.value, 'federalFilterElement', values, options);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={upcomingCatFilter[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, sortMaster);
          setUpcomingCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];
          // console.log(
          //   "##federalFilterElement#:",
          //   options.filterModel.matchMode
          // );
          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          // console.log("federalFilterElement", e.value, values);
          options.filterCallback(values, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const search = useRef()

  const applyGlobalFilter = () => {
    let _filters = { ...filters };
    setSelectedMasters(null)
    if (isClearIcon) {
      search.current.value = "";
      _filters["global"].value = "";
      setIsClearIcon(false);
      onFilterChange({ filters: _filters });
    } else {
      _filters["global"].value = search.current.value;
      setIsClearIcon(true);
      onFilterChange({ filters: _filters });
    }
    setFilters(_filters);
  };

  const fetchFilingMasters = async () => {
    // console.log("ValueCheck", value, "selYear", selectedYear);
    if (getFilingMasters) {
      // console.log("@@Fetch FilingMasters2:");
      try {
        let formData;
        if (value === "1") {
          formData = {
            recordType: "TrackNow",
          };
        } else {
          formData = {
            recordType: "TrackNow",
            year: selectedYear
          };
          // console.log("formData",formData);
        }
        const custList = await getFilingMasters(formData);
        // console.log("@@FilingMasters:", custList);
        const _jusrisdictions = custList.map((item) =>
          item.juristiction ? item.juristiction : ""
        );
        const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));
        // console.log("@@Unique Jurisdiction:", _uniqJurisdictions);
        // setFilingMasterList(custList)
        setJurisdiction(_uniqJurisdictions);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }

  };

  const dateFilterTemplate = (options) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => {
          // console.log("dateFilterTemplate", e.value, options.index);
          return options.filterCallback(e.value, options.index);
        }}
        dateFormat='mm/dd/yy'
        placeholder='mm/dd/yyyy'
        mask='99/99/9999'
      />
    );
  };

  const stateRowFilterTemplate = (options) => {
    if (!masterCatFilter.stateList && options.filterModel.value) {
      // console.log(" optionsfilterModel", options.filterModel);
      options.filterModel.value = [];
      options.value = [];
    }
    return options.filterModel.matchMode === "contains" ? (
      <MultiSelect
        value={masterCatFilter.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("stateRowFilterTemplate:", e, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, stateList: e.value };
          });
          //options.filterApplyCallback(e.value);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "12rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("stateRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, stateList: e.value };
          });
          let values = [];
          // console.log(
          //   "##federalFilterElement#:",
          //   options.filterModel.matchMode
          // );
          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "customFilter_not") {
            values.push(e.value);
          }
          // console.log("federalFilterElement", e.value, values);
          //options.filterApplyCallback(values);
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "12rem" }}
      />
    );
  };


  const cellEditor = (options) => {
    // console.log("##Editor Options:", options);
    return (
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Calendar
          value={options.value ? new Date(options.value) : options.value}
          onChange={(e) => options.editorCallback(e.value)}
          dateFormat='mm/dd/yy'
          placeholder='mm/dd/yyyy'
          mask='99/99/9999'
        />
      </Stack>
    );
  };

  useEffect(() => {
    // if (filingMasterLoaded) 
    // console.log("Show Table Data", filingMasters);

    //eslint-disable-next-line
  }, [filingMasterLoaded]);

  const onRowSelect = (e) => {
    // console.log("@@RowSelect:", e);
  };

  // useEffect(() => {
  // let list = states.map((ele) => ele.state);
  // setStateArray(list);
  //  fetchFilingMasters();

  //eslint-disable-next-line
  // }, []);

  // const handleChange = useCallback((state) => {
  //   setSelectedRows(state.selectedRows);
  // }, []);

  useEffect(() => {
    // console.log("state", selectedRows);
  }, [selectedRows]);

  useEffect(() => {
    console.log("filingMaster", filingMasters);

    // if (filingMasters) {
    // try {
    //   let allCats = [];
    //   let fedLookup = [];
    //   let stateCatLookup = [];
    //   const updFilingMasters = filingMasters
    //     .filter((record) => !record.changesInprogress)
    //     .map((item, i) => {
    //       // console.log(`filingMasters ...`, item);

    //       const _stateList = getStateName(item.stateInfo);

    //       //formatating duedates
    //       const _formattedDueDates = toLocalTime(item?.filingPeriods);
    //       let dueDate =
    //         item?.filingPeriods[0].dueDate !== null
    //           ? new Date(item?.filingPeriods[0].dueDate)
    //           : null;
    //       // console.log('dueDate', item?.filingPeriods[0].dueDate, dueDate);
    //       // const categories = _categories.join(", ");
    //       // console.log(`filingMasters ${item.filingMasters} cat...`, categories);
    //       if (item.juristiction?.includes('Federal')) {
    //         // setFederalCategoriesLookup((old) => [...old, categories]);
    //         const _categories = _.map(
    //           item.businessCategory,
    //           'businessCategoryName'
    //         ).join(', ');
    //         allCats.push(..._categories);
    //         fedLookup.push(..._categories);

    //         return {
    //           ...item,
    //           federalCategories: _categories,
    //           stateList: _stateList,
    //           formattedDueDates: _formattedDueDates,
    //           dueDate,
    //           masterId: i,
    //         };
    //       } else {
    //         // console.log(
    //         //   "stateCategories: props",
    //         //   item.stateInfo,
    //         //   item.businessCategory
    //         // );

    //         const categoriesState = item.businessCategory.filter(
    //           (ele) => ele.state === item.stateInfo
    //         );
    //         // console.log(
    //         //   "stateCategories: filter",
    //         //   item.filingName,
    //         //   categoriesState
    //         // );
    //         const _categories = categoriesState
    //           .map((ele) => ele.businessCategoryName)
    //           .join(', ');
    //         // console.log("stateCategories: join", _categories);
    //         allCats.push(..._categories);
    //         stateCatLookup.push(..._categories);
    //         // setStateCategoriesLookup((old) => [...old, _categories]);
    //         return {
    //           ...item,
    //           stateCategories: _categories,
    //           stateList: _stateList,
    //           formattedDueDates: _formattedDueDates,
    //           dueDate,
    //           masterId: i,
    //         };
    //       }
    //     });
    //   // console.log('Updated filingMasters...', updFilingMasters);
    //   // setData(updCustomers);

    //   setFederalCategoriesLookup(Array.from(new Set(fedLookup)));
    //   setStateCategoriesLookup(Array.from(new Set(stateCatLookup)));
    //   setCategoriesLookup(Array.from(new Set(allCats)));
    //   // setStateCategoriesLookup((old) => new Set(old).values());
    //   setMasters(updFilingMasters);
    // } finally {
    //   setIsLoading(false);
    // }
    // }
    //eslint-disable-next-line
  }, [filingMasters]);

  useEffect(() => {
    if (value) {
      const tabFilters = activeFiltersByTab[value] || [];
      const tabFilterChanges = filterChangesByTab[value] || [];
      setActiveFilters(tabFilters);
      setIsFilterChange(tabFilterChanges);
      setRecordsInViewSafe(0);
      setIsLoading(true);
      setSortingData({ sortBy: "", sortOrder: "" });
      setRefreshRecordList(true);
    }
  }, [value]);
  useEffect(() => {
    if (value === "2") {
      // fetchFilingMasters()
      setRecordsInViewSafe(0);
      setIsLoading(true);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setRefreshRecordList(true);
    };
  }, [selectedYear]);

  const fetchBusinessCategories = async () => {
    console.log("@@Fetch BusinessCategories:", getBusinessCategories);
    if (getBusinessCategories) {
      console.log("@@Fetch BusinessCategories:");
      try {
        let list = []
        const resList = await getBusinessCategories();
        console.log("@@BusinessCategories:", resList);
        list = resList.map((item) => item.businessCategoryName).sort()
        console.log("@@BusinessCategories: list", list);
        setCategoryList(() => list);
        return
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  const initialLoadPage = async () => {
    setLazyLoading(true)
    await fetchConfigs();
    let list = states.map((ele) => ele.state);
    setStateArray(list);
    fetchBusinessCategories()
    if (masters.length <= 0 && !lazyLoading) {
      setRecordsInViewSafe(0)
      setRefreshRecordList(true)
    }
  }

  useEffect(() => {
    initialLoadPage();
  }, []);

  const upcomingDueDates = () => {
    // console.log("upcomingDueDates bef format", masters);
    let currentDate = new Date();
    let upcomingDates = masters.filter((ele) => {
      //  let currentYear = new Date().getFullYear();
      if (ele.filingPeriods.length > 0) {
        let isUpcomingDate = ele.filingPeriods
          // .filter((d) => new Date(d.dueDate).getFullYear() === currentYear)
          .filter((d) => {
            let dueDate = new Date(d.dueDate);
            return dueDate >= currentDate;
          })
          .map((d) => d.dueDate);
        if (isUpcomingDate.length > 0) {
          ele.upcomingDueDates = isUpcomingDate;
          return ele;
        }
      }
    });
    // console.log("upcomingDueDates Format", upcomingDates);

    // console.log("LODASH", upcomingDates);
    let id = 0;
    let upcomingDatesFlat = _.flatMap(upcomingDates, (n) => {
      // console.log("LODASH", n);
      return n.upcomingDueDates.map((ele) => {
        id++;
        // let date = toLocalTime2(ele);
        return {
          ...n,
          //  dueDate: ele !== null ? new Date(date) : null,
          dueDate: ele !== null ? new Date(ele) : null,
          rowId: id,
        };
      });
    });
    // console.log("LODASH", upcomingDatesFlat);

    let sortedData = upcomingDatesFlat.sort(function (a, b) {
      var date1 = new Date(a.dueDate);
      var date2 = new Date(b.dueDate);
      return date1 - date2;
    });
    // console.log("upcomingDueDates", sortedData);
    setSortMaster(sortedData);
  };
  useEffect(() => {
    // upcomingDueDates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortRecord]);

  const applyNewFilter = (filterConfig) => {

    console.log("applyNewFilter filterConfig", filterConfig);

    console.log("applyNewFilter isFilterChange", isFilterChange);

    let filterChange = [...isFilterChange];

    filterChange = filterChange.filter(
      (filterItem) => !filterItem.name.includes(getFilterFieldName(filterConfig.field))
    );

    const isRequiredFilter = filterConfig.field === "required";
    const isJurisdictionFilter = filterConfig.field === "juristiction";
    const normalizedRequiredValue =
      isRequiredFilter && Array.isArray(filterConfig.value)
        ? filterConfig.value[0]
        : filterConfig.value;

    const hasValue = Array.isArray(normalizedRequiredValue)
      ? normalizedRequiredValue.length > 0
      : normalizedRequiredValue !== undefined &&
      normalizedRequiredValue !== null &&
      `${normalizedRequiredValue}`.trim() !== "";

    if (hasValue) {
      if (isRequiredFilter || isJurisdictionFilter) {
        filterChange.push({
          name: getFilterFieldName(filterConfig.field),
          val: normalizedRequiredValue,
        });
      } else if (Array.isArray(normalizedRequiredValue)) {
        normalizedRequiredValue.forEach((val, index) => {
          let changeItem = {
            name: getFilterFieldName(filterConfig.field),
            val: filterConfig.field === 'stateList' ? getStateCode(val) : val,
          };
          if (index === normalizedRequiredValue.length - 1) {
            changeItem.searchType = getFilterSearchType(filterConfig.field);
            changeItem.searchTypeVal = getSearchType(filterConfig.matchMode);
          }
          filterChange.push(changeItem);
        });
      } else {
        filterChange.push({
          name: getFilterFieldName(filterConfig.field),
          val:
            filterConfig.field === 'stateList'
              ? getStateCode(normalizedRequiredValue)
              : normalizedRequiredValue,
          searchType: getFilterSearchType(filterConfig.field),
          searchTypeVal: getSearchType(filterConfig.matchMode),
        });
      }
    }

    handleSetFilterVariable(filterChange);

    const columnLabels = {
      filingName: "Filing Name",
      approverName: "Approver Name",
      filingFrequency: "Filing Frequency",
      stateList: "State",
      ruleInfo: "Rule Info",
      required: "Required",
      federalCategories: "Who Must File Federal",
      stateCategories: "Who Must File in State",
      jsicontactName: "JSI Staff",
      juristiction: "Jurisdiction",
      whereToFile: "Where to File",
      dueDate: "Due Date",
      workflowStatus: "Status",
    };

    const toTitleCaseLabel = (field) =>
      String(field || "")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .trim();

    const updatedFilters = activeFilters.filter(
      (filterItem) => filterItem.field !== filterConfig.field
    );
    if (hasValue) {
      setTabActiveFilters(value, [
        ...updatedFilters,
        {
          field: filterConfig.field,
          label:
            columnLabels[filterConfig.field] ||
            toTitleCaseLabel(filterConfig.field),
          displayValue: Array.isArray(normalizedRequiredValue)
            ? normalizedRequiredValue
            : [normalizedRequiredValue],
          matchMode: filterConfig.matchMode,
          value: normalizedRequiredValue,
        },
      ]);
    } else {
      setTabActiveFilters(value, updatedFilters);
    }
    setSelectedMasters(null);
  };

  const getFilterFieldName = (field) => {
    const fieldMap = {
      filingName: 'SearchByFilingName',
      filingFrequency: 'SearchByFilingFrequency',
      stateList: 'SearchByState',
      ruleInfo: 'SearchByruleInfo',
      required: 'SearchByRequired',
      federalCategories: 'WhoMustFileFederal',
      stateCategories: 'WhoMustFileInState',
      jsicontactName: 'SearchByJSIStaff',
      juristiction: 'SearchByJurisdiction',
      whereToFile: 'SearchByWhereToFile',
      dueDate: 'SearchByDueDate'
    };
    return fieldMap[field] || `SearchBy${field}`;
  };

  const getFilterSearchType = (field) => {
    const searchTypeMap = {
      filingName: 'FilingNameSearchType',
      filingFrequency: 'FilingFrequencySearchType',
      stateList: 'StateSearchType',
      ruleInfo: 'ruleInfoSearchType',
      required: 'RequiredSearchType',
      federalCategories: 'WhoMustFileFederalSearchType',
      stateCategories: 'WhoMustFileInStateSearchType',
      jsicontactName: 'JSIStaffSearchType',
      whereToFile: 'WhereToFileSearchType',
      dueDate: 'DueDateSearchType'
    };
    return searchTypeMap[field] || `${field}SearchType`;
  };

  const removeFilter = (index) => {
    const filterToRemove = activeFilters[index];
    const updatedFilters = activeFilters.filter((_, i) => i !== index);
    setTabActiveFilters(value, updatedFilters);

    const fieldName = getFilterFieldName(filterToRemove.field);
    const updatedFilterChange = isFilterChange.filter(
      (filterItem) => filterItem.name !== fieldName
    );
    handleSetFilterVariable(updatedFilterChange);
  };

  const clearAllFilters = () => {
    setTabActiveFilters(value, []);
    setMasterCatFilter([]);
    setUpcomingCatFilter([]);
    setGlobalFilterValue('');
    setIsClearIcon(false);
    setupcomingDueDateVal("");
    setSelectedMasters(null);
    if (search.current) {
      search.current.value = "";
    }
    setFilters((prev) => ({
      ...prev,
      global: {
        ...prev.global,
        value: null,
      },
    }));
    handleSetFilterVariable([]);
  };

  const sortRecords = async () => {
    // console.log("sortRecords", masters, sortMaster);

    if (sortRecord === "Upcoming Due Dates") {
      setSortRecord("Clear");
      // upcomingDueDates();
      let todayDate = new Date().toISOString().split('T')[0]
      console.log("upcomingDueDates todayDate", todayDate)
      setupcomingDueDateVal(todayDate)
    } else if (sortRecord === "Clear") {
      setSortMaster([]);
      setSortRecord("Upcoming Due Dates");
      setupcomingDueDateVal("")
    }
    setSelectedMasters(null);
    setRecordsInViewSafe(0);
    setIsLoading(true);
    setMastersSafe([]);
    setMasterCatFilter([]);
    setUpcomingCatFilter([]);
    setTabActiveFilters(value, []);
    setFilterAnchorEl(null);
    setGlobalFilterValue('');
    setIsClearIcon(false)
    setFilters({
      ...filters,
      global: {
        ...filters.global,
        value: null,
      },
    });
    setSortingData({ sortBy: "", sortOrder: "" });
    setTabFilterChanges(value, []);

  };
  // console.log("sortMasterCheck", sortMaster);
  const handleYearChange = (event) => {
    setMastersSafe([])
    setSelectedMasters(null)
    setIsLoading(true);
    setGlobalFilterValue([])
    setMasterCatFilter([])
    setTabActiveFilters(value, []);
    setFilterAnchorEl(null);
    // console.log("YearChange", event);
    setSelectedYear(event.target.value);
  };

  const RenderHeader = () => {
    return (
      <Grid container direction="column" spacing={1}>

        {/* ROW 1 — TITLE */}
        <Grid item>
          <Grid container alignItems="center">
            <ArrowBackIosNewIcon
              style={{ marginRight: "10px", cursor: "pointer" }}
              onClick={backToHome}
            />

            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                color: "inherit"
              }}
            >
              {value === "1"
                ? `MASTER LIST ACTIVE (${totalRecords})`
                : `MASTER LIST HISTORY (${totalRecords})`}
            </Typography>
          </Grid>
        </Grid>


        {/* ROW 2 — CONTROLS */}
        <Grid item>
          <Grid
            container
            spacing={2}
            alignItems="center"
            flexWrap="wrap"
            justifyContent="space-between"
          >


            {/* FILTER */}
            <Grid item>
              <TrackNowButton
                variant="secondary"
                size="small"
                onClick={(e) => setFilterAnchorEl(e.currentTarget)}
              >
                + Filter
              </TrackNowButton>
            </Grid>
            {/* YEAR (ONLY HISTORY) */}
            {value === "2" && (
              <Grid item>
                <FormControl size="small" sx={{ minWidth: 120 }}>
                  <InputLabel id="filing-year-select-label">Year</InputLabel>
                  <Select
                    labelId="filing-year-select-label"
                    value={selectedYear}
                    label="Year"
                    onChange={handleYearChange}
                    sx={{
                      backgroundColor: tokens.colors.offWhite,
                      borderRadius: "8px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: `${tableHeaderColor} !important`,
                        borderWidth: "1px !important",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: `${tableHeaderColor} !important`,
                        borderWidth: "1px !important",
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          "& .MuiMenuItem-root": {
                            "&:hover": {
                              backgroundColor: `${alpha(tableHeaderColor, 0.12)} !important`,
                            },
                            "&.Mui-selected": {
                              backgroundColor: `${alpha(tableHeaderColor, 0.18)} !important`,
                              "&:hover": {
                                backgroundColor: `${alpha(tableHeaderColor, 0.24)} !important`,
                              },
                            },
                          },
                        },
                      },
                    }}
                  >
                    {yearsList.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}



            {/* UPCOMING / CLEAR BUTTON */}
            {value === "1" && (
              <Grid item>
                <TrackNowButton
                  variant="primary"
                  onClick={sortRecords}
                  size="small"
                >
                  {sortRecord === "Clear"
                    ? "Clear"
                    : "Upcoming Due Dates"}
                </TrackNowButton>
              </Grid>
            )}

            {/* SEARCH */}
            <Grid item>
              <TextField
                inputRef={search}
                placeholder="Search by Filing Name..."
                size="small"
                sx={{
                  width: 260,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "20px",
                    backgroundColor: tokens.colors.offWhite,
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(0, 0, 0, 0.23)",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: `${tableHeaderColor} !important`,
                      borderWidth: "1px !important",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: `${tableHeaderColor} !important`,
                      borderWidth: "1px !important",
                    },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={applyGlobalFilter} size="small">
                        {isClearIcon ? (
                          <GoogleMaterialIcon name="clear" size={20} style={{ color: tableHeaderColor }} />
                        ) : (
                          <GoogleMaterialIcon name="search" size={20} style={{ color: tableHeaderColor }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

          </Grid>
        </Grid>
        {/* Row 3 */}
        <Grid mb={1} item>
          {activeFilters.map((filter, index) => (
            <Grid key={`${filter.field}-${index}`} sx={{ margin: 0.5 }}>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  backgroundColor: tokens.colors.offWhite,
                  border: '1px solid #ccc',
                  borderRadius: '20px',
                  padding: '6px 12px',
                  fontSize: '13px',
                  color: '#333',
                }}
              >
                <span>
                  {filter.label}:{" "}
                  {Array.isArray(filter.displayValue)
                    ? filter.displayValue.join(', ')
                    : filter.displayValue}
                </span>
                <button
                  onClick={() => removeFilter(index)}
                  style={{
                    marginLeft: '6px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#666',
                    fontSize: '16px',
                  }}
                  type='button'
                >
                  &times;
                </button>
              </div>
            </Grid>
          ))}
        </Grid>

      </Grid>
    );
  };

  const header = RenderHeader();

  const headerDue = header;

  const editMasterFilling = () => {
    if (selectedmasters) {
      delete selectedmasters.stateList;
      const filingPeriodYear = selectedYear
      console.log("selectedmasters", selectedmasters);

      setCurrentFilingMaster(selectedmasters);
      if (value == 2) {
        navigate("/filing-master", {
          state: {
            page: "FilingMasterHistory",
            filingPeriodYear,
            from: "/filing-master-list",
            mode: "edit",
          },
        });
      } else {
        navigate("/filing-master", {
          state: { from: "/filing-master-list", mode: "edit" },
        });
      }

    } else {
      showSelectionRequiredPopup();
      closeDialog();
    }
  };

  const deleteMasterRecord = async () => {
    setIsLoading(true);
    try {
      if (selectedmasters) {
        try {
          let payLoad = { ...selectedmasters };
          //payLoad.changesInprogress = undefined;
          payLoad.createUser = authUser.userId + "";
          payLoad.createDate = new Date();
          payLoad.recordType = "TrackNow"
          delete payLoad.stateList;

          // console.log("pay#", payLoad);
          const res = await deleteDraftFilingMaster(payLoad);
          // console.log("Draft Res:", res);
          if (res) {
            const wfPayload = {
              draftId: res.draftId,
              // currentApproverId: 1,
              WorkflowInitiatorId: authUser?.userId + "",
              createUser: authUser?.userId + "",
              createDate: new Date(),
            };
            let res3 = null;
            if (createFilingMasterWorkflow) {
              res3 = await createFilingMasterWorkflow(wfPayload);
            }
            if (res3) {
              setCurrentFilingMaster(null);
              setRecordsInViewSafe(0);
              setMastersSafe([]);
              setMasterCatFilter([]);
              setUpcomingCatFilter([]);
              setTabActiveFilters(value, []);
              setFilterAnchorEl(null);
              setSelectedMasters(null)
              setGlobalFilterValue('');
              setFilters({
                ...filters,
                global: {
                  ...filters.global,
                  value: null,
                },
              });
              setTabFilterChanges(value, []);
              setSortingData({ sortBy: "", sortOrder: "" });

              showSuccessPopup(
                `Successfully submitted delete request for ${selectedmasters.filingName}`,
                true
              );
              closeDialog();
            }
          } else {
            showErrorPopup(
              `Unexpected error occurred while deleting ${selectedmasters.filingName}`,
              true
            );
            closeDialog();
          }
        } catch (error) {
          console.log("@@Error:", error);
        }
      } else {
        showSelectionRequiredPopup();
        closeDialog();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const FilingCommentButton = ({ rowData }) => {
    const isPermissionEnabled = usePermission("MasterFilingList", "comments", rowData?.customer[0]?.customerId);
    const hasComments = rowData.hasComments;
    const isActive = hasComments && isPermissionEnabled;
    const isDisabled = !isActive;
    return (
      <IconButton
        disabled={!isActive}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          mr: 1,
          pointerEvents: isDisabled ? 'none' : 'auto',
          cursor: isDisabled ? 'default' : 'pointer',
          backgroundColor: isActive ? alpha(tableHeaderColor, 0.12) : 'transparent',
          '&:hover': {
            backgroundColor: isActive ? alpha(tableHeaderColor, 0.22) : 'transparent',
          }
        }}
        onClick={() => addComment(rowData)}
      >
        <GoogleMaterialIcon
          name='comment'
          size={20}
          color={isActive ? tableHeaderColor : tokens.colors.grey}
        />
      </IconButton>
    );
  };
  const FilingAttachmentButton = ({ rowData }) => {
    const isPermissionEnabled = usePermission("MasterFilingList", "referenceDocument", rowData?.customer[0]?.customerId);
    const hasAttachments = rowData.hasAttachments;
    const isActive = hasAttachments && isPermissionEnabled;
    const isDisabled = !isActive;

    return (
      <IconButton
        disabled={!isActive}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          pointerEvents: isDisabled ? 'none' : 'auto',
          cursor: isDisabled ? 'default' : 'pointer',
          backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)' : '#f5f5f5',
          '&:hover': {
            backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 20%, white)' : '#f5f5f5'
          }
        }}
        onClick={() => displayAttachments(rowData)}
      >
        <GoogleMaterialIcon
          name='snippet_folder'
          size={20}
          color={isActive ? tableHeaderColor : tokens.colors.grey}
        />
      </IconButton>
    );
  };

  // const toLocalTimeq = (date) => {
  //   if (date) {
  //     const _date = DateTime.fromFormat(
  //       DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
  //       "dd-MMM-yyyy hh:mm:ss",
  //       { zone: "UTC" }
  //     )
  //       .toLocal()
  //       .toFormat("dd-MMM-yy");
  //     //  console.log("@@@ LocalllTime:", _date);

  //     return _date;
  //   } else return "";
  // };


  const toLocalTime = (dates) => {
    // console.log("filingPeriodscheck", dates);
    if (dates) {
      const localDates = dates.map(date => {
        return date.dueDate ? DateTime.fromFormat(DateTime.fromISO(date.dueDate.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"), "dd-MMM-yyyy hh:mm:ss", { zone: "UTC" }).toLocal()
          .toFormat("M/d/yyyy") : '';
      });
      return localDates.join(', ');
    } else return "";
  };



  // const toLocalTime2 = (date) => {
  //   console.log("toLocalTime", date);
  //   if (date) {
  //     const _date = DateTime.fromFormat(
  //       DateTime.fromISO(date.toString()).toFormat("dd-LL-yyyy hh:mm:ss"),
  //       "dd-LL-yyyy hh:mm:ss",
  //       { zone: "UTC" }
  //     ).toFormat("yyyy-LL-dd");
  //     // console.log("@@@ LocalllTime:", _date);

  //     return _date;
  //   } else return "";
  // };

  const rowExpansionTemplate = (data) => {
    // console.log("rowExpansionTemplate", data.filingPeriods);
    if (data.filingPeriods.length > 0) {
      let tableData = data.filingPeriods.map((ele) => {
        let startDate = new Date(ele.startDate);
        let endDate = new Date(ele.endDate);
        const toLocalDateString = date => {
          const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
          return date.toLocaleDateString('en-US', options).replace(/(\d+)\/(\d+)\/(\d+)/, (_, month, day, year) => `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year}`);
        };

        let fp = `${toLocalDateString(startDate)} - ${toLocalDateString(endDate)}`;
        let dueDate = ele.dueDate !== null ? toLocalDateString(new Date(ele.dueDate)) : null;
        return {
          startDate: ele.startDate,
          endDate: ele.endDate,
          filingPeriod: fp,
          dueDate: dueDate,
        };
      });
      return (
        <div className='filingPeriodTable p-3' style={{ width: "50vw" }}>
          <h5>Due Dates for {data.filingName}</h5>
          <DataTable value={tableData}>
            <Column field='filingPeriod' header='Filing Period'></Column>
            <Column field='dueDate' header='DueDate'></Column>
          </DataTable>
        </div>
      );
    } else {
      return (
        <div className='filingPeriodTable p-3'>
          <h5>No Due Dates for {data.filingName}</h5>
        </div>
      );
    }
  };

  const rowExpand = (event) => {
    // console.log("rowExpand", event, expandedRows);
    setExpandedRows(event.data);
  };

  const tableRef = useRef(null);
  const upcomingTableRef = useRef(null);
  const historyTableRef = useRef(null);
  const pageSize = 100;

  useEffect(() => {
    let frameId = null;
    let detectIntervalId = null;
    let rebindIntervalId = null;
    let attachedElements = [];

    const getScrollContainers = () => {
      const elements = Array.from(
        document.querySelectorAll(
          ".frozen-filing-master .p-datatable-wrapper, .frozen-filing-master .p-virtualscroller, .frozen-filing-master .p-virtualscroller-content"
        )
      );
      return elements.filter((element, index) => elements.indexOf(element) === index);
    };

    const syncHorizontalScrollState = () => {
      const hasHorizontalScroll = getScrollContainers().some(
        (container) =>
          container?.offsetParent !== null &&
          container.scrollWidth - container.clientWidth > 2 &&
          (container.scrollLeft ?? 0) > 10
      );
      if (frozenColumnsCondensedRef.current !== hasHorizontalScroll) {
        frozenColumnsCondensedRef.current = hasHorizontalScroll;
        setIsFrozenColumnsCondensed(hasHorizontalScroll);
      }
    };

    const scheduleSync = () => {
      if (frameId !== null) {
        return;
      }
      frameId = window.requestAnimationFrame(() => {
        frameId = null;
        syncHorizontalScrollState();
      });
    };

    const attachScrollListeners = () => {
      const nextElements = getScrollContainers();
      const sameElements =
        nextElements.length === attachedElements.length &&
        nextElements.every((element, index) => element === attachedElements[index]);
      if (sameElements) {
        return;
      }

      attachedElements.forEach((element) =>
        element.removeEventListener("scroll", scheduleSync)
      );
      attachedElements = nextElements;
      attachedElements.forEach((element) =>
        element.addEventListener("scroll", scheduleSync, { passive: true })
      );
    };

    attachScrollListeners();
    scheduleSync();
    window.addEventListener("resize", scheduleSync, { passive: true });
    detectIntervalId = window.setInterval(syncHorizontalScrollState, 120);
    rebindIntervalId = window.setInterval(attachScrollListeners, 600);

    return () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
      if (detectIntervalId !== null) {
        window.clearInterval(detectIntervalId);
      }
      if (rebindIntervalId !== null) {
        window.clearInterval(rebindIntervalId);
      }
      attachedElements.forEach((element) =>
        element.removeEventListener("scroll", scheduleSync)
      );
      window.removeEventListener("resize", scheduleSync);
    };
  }, [value, sortRecord, filingMasters.length, isLoading]);

  // lazy load function
  const loadDataLazy = async (event) => {
    const hasHorizontalScrollNow = Array.from(
      document.querySelectorAll(
        ".frozen-filing-master .p-datatable-wrapper, .frozen-filing-master .p-virtualscroller, .frozen-filing-master .p-virtualscroller-content"
      )
    ).some(
      (container) =>
        container?.offsetParent !== null &&
        container.scrollWidth - container.clientWidth > 2 &&
        (container.scrollLeft ?? 0) > 10
    );
    if (frozenColumnsCondensedRef.current !== hasHorizontalScrollNow) {
      frozenColumnsCondensedRef.current = hasHorizontalScrollNow;
      setIsFrozenColumnsCondensed(hasHorizontalScrollNow);
    }

    if (Date.now() < programmaticScrollMuteUntilRef.current) {
      return;
    }
    if (lazyLoadInFlightRef.current || lazyLoading) {
      return;
    }

    //Virtual scroll callback
    const vScroll = value === "1"
      ? sortRecord === "Clear"
        ? upcomingTableRef.current.getVirtualScroller()
        : tableRef.current.getVirtualScroller()
      : historyTableRef.current.getVirtualScroller()
    if (!vScroll) {
      return;
    }
    let range = vScroll.getRenderedRange();
    if (!range?.viewport) {
      return;
    }
    let { first, last } = range.viewport;

    const currentRecordsInView = recordsInViewRef.current;
    const currentMastersLength = mastersRef.current.length;
    let firstVal = currentRecordsInView * pageSize;

    if (
      firstVal < totalRecords &&
      first > currentMastersLength - pageSize / 5 &&
      !lazyLoading
    ) {
      //scroll down
      lazyLoadInFlightRef.current = true;
      setLazyLoading(true);
      const lastVal = Math.min(firstVal + pageSize, totalRecords);
      try {
        //get next data
        const records = await loadRecordsList(firstVal, lastVal, "down");
        if (Array.isArray(records) && records.length > 0) {
          requestAnimationFrame(() => {
            programmaticScrollMuteUntilRef.current = Date.now() + 220;
            if (typeof vScroll.scrollInView === "function") {
              vScroll.scrollInView(currentRecordsInView * 100);
            } else if (typeof vScroll.scrollToIndex === "function") {
              vScroll.scrollToIndex(currentRecordsInView * 100);
            }
          });
          setRecordsInViewSafe((old) => old + 1);
        }
      } finally {
        setLazyLoading(false);
        setIsLoading(false);
        lazyLoadInFlightRef.current = false;
      }
    } else if (last < pageSize / 5 && currentRecordsInView > 1 && !lazyLoading) {
      // scroll up
      const upFirstVal = (currentRecordsInView - 3) * pageSize;
      const upLastVal = Math.min(upFirstVal + pageSize, totalRecords);
      if (upFirstVal >= 0) {
        lazyLoadInFlightRef.current = true;
        setLazyLoading(true);
        try {
          //get prev data
          const records = await loadRecordsList(upFirstVal, upLastVal, "up");
          if (Array.isArray(records) && records.length > 0) {
            requestAnimationFrame(() => {
              programmaticScrollMuteUntilRef.current = Date.now() + 220;
              if (typeof vScroll.scrollToIndex === "function") {
                vScroll.scrollToIndex(pageSize * 1.5);
              } else if (typeof vScroll.scrollInView === "function") {
                vScroll.scrollInView(pageSize * 1.5);
              }
            });
            setRecordsInViewSafe((old) => old - 1);
          }
        } finally {
          setLazyLoading(false);
          setIsLoading(false);
          lazyLoadInFlightRef.current = false;
        }
      } else if (typeof vScroll.scrollToIndex === "function") {
        vScroll.scrollToIndex(0);
      } else if (typeof vScroll.scrollInView === "function") {
        vScroll.scrollInView(0);
      }
    }
  };

  // api call for lazy load
  const loadRecordsList = async (first, last, direction) => {
    setIsLoading(true);
    const requestId = ++recordsRequestIdRef.current;
    let url = `${API_BASE_URL}/FilingMaster/FilingMasterListByPagination?StartRow=${first + 1}&EndRow=${last}&recordType=TrackNow`

    if (value === "2" && selectedYear !== "") {
      url = `${url}&Year=${selectedYear}`;
    }

    if (upcomingDueDateVal !== "") {
      url = `${url}&SearchByUpcomingDuedate=${upcomingDueDateVal}`;
    }

    // console.log("loadRecordsList fliter/sort",isFilterChange,sortingData);
    if (isFilterChange !== undefined && isFilterChange.length > 0) {
      // url filter parameters
      isFilterChange.forEach((ele) => {
        const filterName = encodeURIComponent(ele.name);
        const filterValue = encodeURIComponent(ele.val);
        const searchType = ele.searchType ? encodeURIComponent(ele.searchType) : "";
        const searchTypeVal = ele.searchTypeVal
          ? encodeURIComponent(ele.searchTypeVal)
          : "";
        url = `${url}&${filterName}=${filterValue}${ele.searchType ? `&${searchType}=${searchTypeVal}` : ``
          }`;
      });
    }

    if (
      sortingData &&
      typeof sortingData === "object" &&
      sortingData.sortBy !== "" &&
      sortingData.sortOrder !== ""
    ) {
      // url sort parameters
      let sortParameter = getSortData(sortingData.sortBy);
      let order = sortingData.sortOrder === 1 ? "Ascending" : "Descending"
      url = `${url}&${sortParameter.SortByParameter}=${sortParameter.SortByVal}&${sortParameter.SortOrderParameter}=${order}`;
    }

    try {
      //get data
      const res = await axios.get(url);
      if (requestId !== recordsRequestIdRef.current) {
        return [];
      }

      if (res.data) {
        let ogList =
          first === 0 ? [] : mastersRef.current.map((ele) => ele);
        await modifyList(res.data.items, direction, ogList);
        setTotalRecords(res.data.totalItems);
        // setMasters(res.data.items)
        return res.data.items;
      } else {
        return false;
      }
    } catch (err) {
      console.log("loadRecordsList err", err);
    }
  };

  //maping records for lazy load
  const modifyList = (list, direction, ogList) => {
    console.log("modifyList", list, direction);
    if (list.length > 0) {
      //list has data


      // setOgList(og)    

      // console.log("loadDataLazy og", ogList, masters);
      // console.log("modifyList og", ogList, masters);

      let allCats = [];
      let fedLookup = [];
      let stateCatLookup = [];

      //formating list
      const updFilingMasters = list
        .map((item, i) => {
          // console.log(`filingMasters ...`, item);

          const _stateList = getStateName(item.stateInfo);

          //formatating duedates
          const _formattedDueDates = toLocalTime(item?.filingPeriods);
          let dueDate =
            item?.filingPeriods[0].dueDate !== null
              ? new Date(item?.filingPeriods[0].dueDate)
              : null;

          //formatating juristiction
          if (item.juristiction?.includes('Federal')) {
            const _categories = _.map(
              item.businessCategory,
              'businessCategoryName'
            ).join(', ');
            // console.log("federalCategories: join", _categories);

            allCats.push(..._categories);
            fedLookup.push(..._categories);

            return {
              ...item,
              federalCategories: _categories,
              stateList: _stateList,
              formattedDueDates: _formattedDueDates,
              dueDate,
              masterId: `${i}${item.filingId}`,
            };
          } else {
            //get state categories 
            const categoriesState = item.businessCategory.filter(
              (ele) => ele.state === item.stateInfo
            );
            const _categories = categoriesState
              .map((ele) => ele.businessCategoryName)
              .join(', ');
            // console.log("stateCategories: join", _categories);

            allCats.push(..._categories);
            stateCatLookup.push(..._categories);

            return {
              ...item,
              stateCategories: _categories,
              stateList: _stateList,
              formattedDueDates: _formattedDueDates,
              dueDate,
              masterId: `${i}${item.filingId}`,
            };
          }
        });
      // console.log("modifyList updFilingMasters", updFilingMasters);


      let updFilingMastersList
      if (direction === "down") {
        //scroll down
        if (ogList.length >= 200) {
          //list > 200

          //slice 2 half of list
          let unloadList = ogList.slice(
            ogList.length - pageSize,
            ogList.length
          );

          //add new data
          updFilingMastersList = [...unloadList, ...updFilingMasters];

          let list = updFilingMastersList.map((ele) => ele)
          setMastersSafe(list);
          setFilingMasters(list)
          console.log("modifyList list", list);
        } else {
          //list < 200

          // add new data to list
          updFilingMastersList = [...ogList, ...updFilingMasters];
          let list = updFilingMastersList.map((ele) => ele)
          setMastersSafe(list);
          setFilingMasters(list)
          console.log("modifyList list", list);

        }
      } else if (direction === "up") {
        //scroll up
        if (ogList.length >= 200) {
          //list > 200

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);

          //add new data
          updFilingMastersList = [...updFilingMasters, ...unloadList];

          let list = updFilingMastersList.map((ele) => ele)
          setMastersSafe(list);
          setFilingMasters(list)
          console.log("modifyList list", list);

        } else {
          //list < 200

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);

          //add new data
          updFilingMastersList = [...updFilingMasters, ...unloadList];
          let list = updFilingMastersList.map((ele) => ele)
          setMastersSafe(list);
          setFilingMasters(list)
          console.log("modifyList list", list);

        }
      }

      setFederalCategoriesLookup(Array.from(new Set(fedLookup)));
      setStateCategoriesLookup(Array.from(new Set(stateCatLookup)));
      setCategoriesLookup(Array.from(new Set(allCats)));
      setRefreshRecordList(false)
      setIsLoading(false);
      return updFilingMastersList
    } else {
      //list empty
      // console.log("modifyList empty",list)
      setIsLoading(false);
      setMastersSafe([]);
      setFilingMasters([])
      return []

    }
  };

  //table filter change
  const onFilterChange = async (e) => {
    console.log("onFilterChange props", e.filters);
    let filterChange = [];

    const getConstraintValue = (col) => e?.filters?.[col]?.constraints?.[0]?.value;
    const getConstraintMatchMode = (col) => e?.filters?.[col]?.constraints?.[0]?.matchMode;

    const getValueList = (value) =>
      (Array.isArray(value) ? value : [value]).filter(
        (item) => item !== null && item !== undefined && item !== ""
      );

    const pushMultiValueFilters = ({
      name,
      searchType,
      values,
      matchMode,
      transformValue = (value) => value,
    }) => {
      const normalizedValues = getValueList(values);
      normalizedValues.forEach((rawValue, index) => {
        const changeItem = {
          name,
          val: transformValue(rawValue),
        };
        if (index + 1 === normalizedValues.length && searchType) {
          changeItem.searchType = searchType;
          changeItem.searchTypeVal = getSearchType(matchMode);
        }
        filterChange.push(changeItem);
      });
    };

    if (e.filters.global.value !== "" && e.filters.global.value !== null) {
      //global filter
      filterChange.push({
        name: `SearchByFilingName`,
        val: e.filters.global.value,
        searchType: `FilingNameSearchType`,
        searchTypeVal: getSearchType("contains"),
      });
    } else {
      //map filter event
      Object.keys(e.filters).forEach((col) => {
        console.log("onFilterChange col", col, e.filters[col]);
        if (
          e.filters[col].constraints &&
          e.filters[col].constraints[0].value !== null
        ) {
          if (col === "stateList") {
            const stateValue = getConstraintValue(col);
            const stateMode = getConstraintMatchMode(col);
            Array.isArray(stateValue)
              ? pushMultiValueFilters({
                name: `SearchByState`,
                searchType: `StateSearchType`,
                values: stateValue,
                matchMode: stateMode,
                transformValue: (value) => getStateCode(value),
              })
              : filterChange.push({
                name: `SearchByState`,
                val: getStateCode(stateValue),
                searchType: `StateSearchType`,
                searchTypeVal: getSearchType(stateMode),
              });
          } else if (col === "juristiction") {
            filterChange.push({
              name: `SearchByJurisdiction`,
              val: getConstraintValue(col),
            });
          } else if (col === "required") {
            filterChange.push({
              name: `SearchByRequired`,
              val: getConstraintValue(col),
            });
          } else if (col === "jsicontactName") {
            filterChange.push({
              name: `SearchByJSIStaff`,
              val: getConstraintValue(col),
              searchType: `JSIStaffSearchType`,
              searchTypeVal: getSearchType(getConstraintMatchMode(col)),
            });
          } else if (col === "dueDate") {
            filterChange.push({
              name: `SearchByDueDate`,
              val: formatFilterDate(getConstraintValue(col)),
              searchType: `DueDateSearchType`,
              searchTypeVal: getSearchType(getConstraintMatchMode(col)),
            });
          } else if (col === "federalCategories") {
            pushMultiValueFilters({
              name: `WhoMustFileFederal`,
              searchType: `WhoMustFileFederalSearchType`,
              values: getConstraintValue(col),
              matchMode: getConstraintMatchMode(col),
            });
          } else if (col === "stateCategories") {
            pushMultiValueFilters({
              name: `WhoMustFileInState`,
              searchType: `WhoMustFileInStateSearchType`,
              values: getConstraintValue(col),
              matchMode: getConstraintMatchMode(col),
            });
          } else {
            filterChange.push({
              name: `SearchBy${col}`,
              val: getConstraintValue(col),
              searchType: `${col}SearchType`,
              searchTypeVal: getSearchType(getConstraintMatchMode(col)),
            });
          }
        }
      });
    }

    //set filter
    console.log("onFilterChange filterChange", filterChange);
    handleSetFilterVariable(filterChange);
  };

  const formatFilterDate = (date) => {
    // console.log("formatFilterDate", date);
    let getDate = new Date(date);
    let formatDate = `${getDate.getFullYear()}-${getDate.getMonth() + 1
      }-${getDate.getDate()}`;
    // console.log("formatFilterDate formatDate", getDate.getFullYear(), formatDate);
    return formatDate;
  };

  const getStateCode = (stateName) => {
    // console.log("getStateCode", stateName, states);
    const state = states.find((s) => s.state === stateName);
    return state ? state.code : stateName;
  };

  const matchModeVal = [
    { name: "contains", val: "Contains" },
    { name: "in", val: "Contains" },
    { name: "notContains", val: "NotContains" },
    { name: "equals", val: "EqualTo" },
    { name: "dateIs", val: "DateIs" },
    { name: "dateIsNot", val: "DateIsNot" },
    { name: "dateBefore", val: "DateIsBefore" },
    { name: "dateAfter", val: "DateIsAfter" },
  ];

  const getSearchType = (matchMode) => {
    // console.log("getSearchType props", matchMode);
    return matchModeVal.find((ele) => ele.name === matchMode).val;
  };

  const getSortData = (val) => {
    console.log("getSortData props", val);
    if (val === "dueDate") {
      return {
        SortByParameter: "SortByDuedate",
        SortByVal: "DueDate",
        SortOrderParameter: "SortOrderDuedate"
      }
    } else if (val === "stateList") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "StateInfo",
        SortOrderParameter: "SortOrder"
      }
    } else if (val === "federalCategories" || val === "stateCategories") {
      return {
        SortByParameter: "SortByBusinessCategory",
        SortByVal: "BusinessCategory",
        SortOrderParameter: "SortOrderBusinessCategory"
      }
    } else {
      return {
        // SortByParameter: `SortBy${val.charAt(0).toUpperCase() + val.slice(1)}`,
        SortByParameter: `SortBy`,
        SortByVal: val.charAt(0).toUpperCase() + val.slice(1),
        // SortOrderParameter: `SortOrder${val.charAt(0).toUpperCase() + val.slice(1)}`
        SortOrderParameter: `SortOrder`
      }
    }
  }

  //set filter
  const handleSetFilterVariable = (filterChange) => {
    console.log("handleSetFilterVariable props", filterChange);
    setTabFilterChanges(value, filterChange);
    setRecordsInViewSafe(0);
    setIsLoading(true);
    setMastersSafe([]);
  };

  //table sort change
  const handleSort = async (e) => {
    // console.log("handleSort props",e ,e.sortField)
    if (e.sortField !== "") {
      setSortingData(() => ({
        sortBy: e.sortField,
        sortOrder: e.sortOrder,
      }));
      setRecordsInViewSafe(0);
      setMastersSafe([]);
      setIsLoading(true)
    }
  }

  useEffect(() => {
    console.log("filter/sort change", isFilterChange, sortingData, !lazyLoading, !refreshRecordList);
    //on filter/sort change
    if (!lazyLoading && !refreshRecordList) {
      const sortAndFilterApiCall = async () => {
        console.log("LOAD Check 4");
        let records = await loadRecordsList(0, 100, "down");
        // console.log("recordsCheck", records);
        setIsLoading(false);
        setRecordsInViewSafe(1)
      };
      sortAndFilterApiCall();
    }
  }, [isFilterChange, sortingData]);

  const refreshRecords = async () => {
    console.log("refreshRecords props")

    //Virtual scroll callback
    const vScroll = value === "1"
      ? sortRecord === "Clear"
        ? upcomingTableRef.current.getVirtualScroller()
        : tableRef.current.getVirtualScroller()
      : historyTableRef.current.getVirtualScroller()
    let range = vScroll.getRenderedRange();
    console.log("refreshRecords vScroll range", vScroll, range);

    let records
    console.log("refreshRecords refreshDetails", refreshDetails);
    if (refreshDetails?.pageInView || refreshDetails?.noOfPages) {
      let first = refreshDetails.pageInView * pageSize
      records = await loadRecordsList(first, first + refreshDetails?.noOfPages * pageSize, "down");
    } else {
      records = await loadRecordsList(0, pageSize, "down");
    }
    // console.log("refreshRecords records", records, props.keepSelectedRecords);

    if (records) {
      if (refreshDetails?.viewport && refreshDetails?.noOfPages) {
        setRecordsInViewSafe((old) => old + refreshDetails?.noOfPages);
        // setRefreshDetails(null)
      } else {
        setRecordsInViewSafe((old) => old + 1);
      }
      setLazyLoading(false)
    }
  }


  useEffect(() => {
    console.log("refreshRecordList,", refreshRecordList, !lazyLoading);
    if (refreshRecordList && !lazyLoading) {
      setLazyLoading(true);
      refreshRecords()
    }

  }, [refreshRecordList])

  const handleRrefreshList = () => {
    //Virtual scroll callback
    const vScroll = value === "1"
      ? sortRecord === "Clear"
        ? upcomingTableRef.current.getVirtualScroller()
        : tableRef.current.getVirtualScroller()
      : historyTableRef.current.getVirtualScroller()
    let range = vScroll.getRenderedRange();
    console.log("refreshTable vScroll", vScroll, range);

    let pageInView
    let noOfPages
    if (masters.length > 100) {
      pageInView = recordsInView - 2
      noOfPages = 2
    } else {
      pageInView = recordsInView - 1
      noOfPages = 1
    }
    let clientSelected = masters
    console.log("refreshTable clientSelected", masters, clientSelected);

    setRecordsInViewSafe(pageInView)
    setRefreshDetails({
      viewport: range.viewport,
      pageInView,
      noOfPages,
      clientSelected
    })

    setRefreshRecordList(true)
    setIsLoading(true);
    setIsFilterChange([]);
    setMastersSafe([])
    setSortingData({ sortBy: "", sortOrder: "" });
  }

  useEffect(() => {
    console.log("Total Records updated:", totalRecords);
  }, [totalRecords]);

  useEffect(() => {
    console.log("recordsInView,", recordsInView);
    recordsInViewRef.current = recordsInView;
  }, [recordsInView]);

  useEffect(() => { console.log("lazyLoading", lazyLoading) }, [lazyLoading])

  useEffect(() => { console.log("isLoading", isLoading) }, [isLoading])

  useEffect(() => {
    console.log("masters,", masters);
    mastersRef.current = masters;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masters, masters.length, JSON.stringify(masters)]);

  const filingMasterTableClassName = isFrozenColumnsCondensed
    ? "frozen-filing-master frozen-filing-master--scrolled"
    : "frozen-filing-master";
  const frozenColumnWidths = isFrozenColumnsCondensed
    ? { filingName: "250px", filingFrequency: "160px", dueDate: "130px" }
    : { filingName: "300px", filingFrequency: "180px", dueDate: "150px" };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        px: { xs: 1, sm: 2, md: 3, lg: 4 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
          width: "100%",
          maxWidth: "1800px",
        }}
      >

        {/* LEFT SIDE (Tabs + Table) */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <div
            className='card'
            style={{
              maxWidth: "90vw",
              padding: "1rem",
              // margin: "1rem",
              background: tokens.colors.offWhite,
              borderRadius: "8px",
              position: "relative",
            }}
          >
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabChange}>
                  <Tab label='Master Active' value='1' disabled={isLoading} />
                  <Tab label='Master History' value='2' disabled={isLoading} />
                </TabList>
              </Box>
              <TabPanel value='1'>
                {sortRecord === "Clear" ? (
                  <DataTable
                    className='frozen-filing-master'
                    resizableColumns
                    columnResizeMode='expand'
                    showGridlines
                    key='sortedlist'
                    scrollable
                    value={filingMasters}
                    selection={selectedmasters}
                    onSelectionChange={(e) => setSelectedMasters(e.value)}
                    dataKey='masterId'
                    filters={filters}
                    loading={isLoading}
                    // filterDisplay="row"
                    globalFilterFields={["filingName"]}
                    header={headerDue}
                    ref={upcomingTableRef}
                    virtualScrollerOptions={{
                      // lazy: true,
                      onScroll: loadDataLazy,
                      itemSize: 45,
                      delay: 0,
                      scrollHeight: "550px",
                      appendOnly: true,
                      // showLoader: true,
                      // loading: lazyLoading,
                      // loadingTemplate,
                    }}
                    style={{ width: "100%", minWidth: "100%", borderRadius: "8px", overflow: "hidden", border: "none", background: tokens.colors.offWhite }}
                    scrollHeight="550px"
                    onFilter={(e) => onFilterChange(e)}
                    sortField={sortingData.sortBy}
                    sortOrder={sortingData.sortOrder}
                    onSort={(e) => handleSort(e)}
                  >
                    <Column
                      selectionMode='single'
                      headerStyle={{ width: "50px", minWidth: "50px", maxWidth: "50px" }}
                      style={{ width: "50px", minWidth: "50px", maxWidth: "50px", margin: "0", textAlign: "center" }}
                    >
                      Select
                    </Column>
                    <Column
                      header='Indicators'
                      headerStyle={{ width: "90px", minWidth: "90px", maxWidth: "90px" }}
                      style={{ width: "90px", minWidth: "90px", maxWidth: "90px", textAlign: "center" }}
                      body={(rowData) => (
                        <>
                          <Stack direction='row'>
                            <FilingCommentButton rowData={rowData} />
                            <FilingAttachmentButton rowData={rowData} />
                          </Stack>
                        </>
                      )}
                    ></Column>
                    <Column
                      field='filingName'
                      header='Filing Name'
                      sortable
                      filter
                      className='filingNameColumn-fm frozen-filing-name-col'
                      headerClassName='frozen-filing-name-col'
                      frozen={enableForzen}

                      filterPlaceholder='Search by Filing Name'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        {
                          value: FilterMatchMode.NOT_CONTAINS,
                          label: "Not Contains",
                        },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      headerStyle={{
                        width: frozenColumnWidths.filingName,
                        minWidth: frozenColumnWidths.filingName,
                        maxWidth: frozenColumnWidths.filingName,
                      }}
                      style={{
                        width: frozenColumnWidths.filingName,
                        minWidth: frozenColumnWidths.filingName,
                        maxWidth: frozenColumnWidths.filingName,
                      }}
                      body={(rowData) => cellListDisplayName(rowData)}
                    ></Column>
                    <Column
                      field='filingFrequency'
                      header='Filing Frequency'
                      filter
                      className='frozen-filing-frequency-col'
                      headerClassName='frozen-filing-frequency-col'
                      frozen={enableForzen}

                      filterPlaceholder='Search by Frequency'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        {
                          value: FilterMatchMode.NOT_CONTAINS,
                          label: "Not Contains",
                        },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      headerStyle={{
                        width: frozenColumnWidths.filingFrequency,
                        minWidth: frozenColumnWidths.filingFrequency,
                        maxWidth: frozenColumnWidths.filingFrequency,
                      }}
                      style={{
                        width: frozenColumnWidths.filingFrequency,
                        minWidth: frozenColumnWidths.filingFrequency,
                        maxWidth: frozenColumnWidths.filingFrequency,
                      }}
                    ></Column>
                    <Column
                      field='dueDate'
                      header='Due Date'
                      dataType='date'
                      filter
                      className='frozen-due-date-col'
                      headerClassName='frozen-due-date-col'
                      frozen={enableForzen}

                      filterField='dueDate'
                      filterPlaceholder='Search by Due Date'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterElement={dateFilterTemplate}
                      editor={(options) => cellEditor(options)}
                      headerStyle={{
                        width: frozenColumnWidths.dueDate,
                        minWidth: frozenColumnWidths.dueDate,
                        maxWidth: frozenColumnWidths.dueDate,
                      }}
                      style={{
                        width: frozenColumnWidths.dueDate,
                        minWidth: frozenColumnWidths.dueDate,
                        maxWidth: frozenColumnWidths.dueDate,
                      }}
                      sortable
                      body={cellListDisplayDueDate}
                    ></Column>
                    <Column
                      field='stateList'
                      header='State'
                      sortable
                      filter
                      filterField='stateList'
                      filterPlaceholder='Search by State'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      filterMenuStyle={{ width: "15rem" }}
                      filterElement={stateRowFilterTemplate}
                      onFilterMatchModeChange={() => setMasterCatFilter([])}
                      onFilterClear={() => setMasterCatFilter([])}
                      style={{ minWidth: "13rem" }}
                      className='column-small'
                    ></Column>
                    <Column
                      field='ruleInfo'
                      header='Rule Info'
                      filter
                      filterPlaceholder='Search by Rule Info'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        {
                          value: FilterMatchMode.NOT_CONTAINS,
                          label: "Not Contains",
                        },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      style={{ minWidth: "15rem", maxWidth: "15rem" }}
                      body={(rowData) => cellListDisplayRuleInfo(rowData)}
                    ></Column>
                    <Column
                      field='required'
                      header='Required?'
                      filter
                      filterField="required"
                      filterElement={upcommingRequiredRowFilterTemplate}
                      onFilterClear={() => setUpcomingCatFilter([])}
                      showFilterMatchModes={false}
                      filterPlaceholder='Search by Required'
                      showAddButton={false}
                      showFilterOperator={false}
                      style={{ minWidth: "13rem" }}
                      className='column-small'
                    ></Column>
                    <Column
                      field='federalCategories'
                      header='Who Must File Federal'
                      className='expandableColumn-fm'
                      // sortable
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "federalCategories")
                      }
                      filter
                      filterField='federalCategories'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.IN, label: "Contains" },
                        { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      onFilterMatchModeChange={() => setUpcomingCatFilter([])}
                      filterPlaceholder='Search by Cateogry'
                      filterElement={(options) =>
                        upcomingCategoryFilter(options, "federalCategories")
                      }
                      onFilterClear={() => setUpcomingCatFilter([])}
                      style={{ minWidth: "18rem", maxWidth: "18rem" }}
                    // filterFunction={customCategoryFilter}
                    // showFilterMenu={false}
                    //filterMenuStyle={{ width: "14rem" }}
                    //  showClearButton={false}
                    ></Column>
                    <Column
                      field='stateCategories'
                      header='Who Must File in State'
                      className='expandableColumn-fm'
                      // sortable
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "stateCategories")
                      }
                      filter
                      filterField='stateCategories'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.IN, label: "Contains" },
                        { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      onFilterMatchModeChange={() => setUpcomingCatFilter([])}
                      filterPlaceholder='Search by Cateogry'
                      filterElement={(options) =>
                        upcomingCategoryFilter(options, "stateCategories")
                      }
                      onFilterClear={() => setUpcomingCatFilter([])}
                      style={{ minWidth: "18rem", maxWidth: "18rem" }}
                    //showFilterMenu={false}
                    //filterMenuStyle={{ width: "14rem" }}
                    //  showClearButton={false}
                    ></Column>
                    <Column
                      field='jsicontactName'
                      header='JSI Staff'
                      filter
                      filterPlaceholder='Search by JSI Staff'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        {
                          value: FilterMatchMode.NOT_CONTAINS,
                          label: "Not Contains",
                        },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      style={{ minWidth: "12rem" }}
                    ></Column>
                    <Column
                      field='juristiction'
                      header='Jurisdiction'
                      sortable
                      filterField='juristiction'
                      showAddButton={false}
                      showFilterOperator={false}
                      showFilterMatchModes={false}
                      //showFilterMenu={false}
                      //filterMenuStyle={{ width: "10rem" }}
                      style={{ minWidth: "10rem" }}
                      filter
                      filterElement={upcomingJurisdictionRowFilterTemplate}
                      onFilterMatchModeChange={() => setUpcomingCatFilter([])}
                      onFilterClear={() => setUpcomingCatFilter([])}
                    ></Column>
                    <Column
                      field='whereToFile'
                      header='Where to File'
                      filter
                      body={(rowData) => cellListDisplayWhereToFile(rowData)}
                      filterPlaceholder='Search by Where To File'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        {
                          value: FilterMatchMode.NOT_CONTAINS,
                          label: "Not Contains",
                        },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      showFilterMenu={true}
                      filterMenuStyle={{ width: "10rem" }}
                      style={{ minWidth: "13rem", maxWidth: "13rem" }}
                    ></Column>
                    <Column
                      field='notes'
                      header='Notes'
                      headerStyle={{
                        minWidth: "20rem",
                        maxWidth: "20rem",
                        justifyItems: "center",
                      }}
                      style={{ minWidth: "45rem", maxWidth: "45rem" }}
                      body={(rowData) => cellListDisplayNotes(rowData)}
                      headerClassName='centered-header'
                    ></Column>
                  </DataTable>
                ) : (
                  <DataTable
                    className='frozen-filing-master'
                    key='list'
                    scrollable
                    resizableColumns
                    columnResizeMode='expand'
                    showGridlines
                    value={filingMasters}
                    selection={selectedmasters}
                    onSelectionChange={(e) => setSelectedMasters(e.value)}
                    dataKey='masterId'
                    onRowSelect={onRowSelect}
                    loading={isLoading}
                    // onRowToggle={(e) => rowExpand(e)}
                    // rowExpansionTemplate={rowExpansionTemplate}
                    // expandedRows={expandedRows}
                    // paginator
                    // rows={10}
                    // rowsPerPageOptions={[5, 10, 25, 50]}
                    // filterDisplay="row"
                    globalFilterFields={["filingName"]}
                    header={header}
                    ref={tableRef}
                    virtualScrollerOptions={{
                      // lazy: true,
                      onScroll: loadDataLazy,
                      itemSize: 45,
                      delay: 0,
                      scrollHeight: "550px",
                      appendOnly: true,
                      // showLoader: true,
                      // loading: lazyLoading,
                      // loadingTemplate,
                    }}
                    style={{ width: "100%", minWidth: "100%", borderRadius: "8px", overflow: "hidden", border: "none", background: tokens.colors.offWhite }}
                    filters={filters}
                    scrollHeight="550px"
                    onFilter={(e) => onFilterChange(e)}
                    sortField={sortingData.sortBy}
                    sortOrder={sortingData.sortOrder}
                    onSort={(e) => handleSort(e)}
                  >
                    {/* <Column expander={true} style={{ width: "5rem" }} /> */}
                    <Column
                      selectionMode='single'
                      headerStyle={{ width: "50px", minWidth: "50px", maxWidth: "50px" }}
                      style={{ width: "50px", minWidth: "50px", maxWidth: "50px", margin: "0", textAlign: "center" }}
                    >
                      Select
                    </Column>
                    {/* <Column
                  headerStyle={{ width: "2rem" }}
                  // header="Attachemts"
                  body={(rowData) => <FilingCommentButton rowData={rowData} />}
                ></Column>
                <Column
                  headerStyle={{ width: "2rem" }}
                  // header="Attachemts"
                  body={(rowData) => (
                    <FilingAttachmentButton rowData={rowData} />
                  )}
                ></Column> */}
                    <Column
                      header='Indicators'
                      headerStyle={{ width: "90px", minWidth: "90px", maxWidth: "90px" }}
                      style={{ width: "90px", minWidth: "90px", maxWidth: "90px", textAlign: "center" }}
                      body={(rowData) => (
                        <>
                          <Stack direction='row'>
                            <FilingCommentButton rowData={rowData} />

                            <FilingAttachmentButton rowData={rowData} />
                          </Stack>
                        </>
                      )}
                    ></Column>
                    <Column
                      field='filingName'
                      header='Filing Name'
                      sortable
                      filter
                      frozen={enableForzen}

                      className='filingNameColumn-fm frozen-filing-name-col'
                      headerClassName='frozen-filing-name-col'
                      filterPlaceholder='Search by Filing Name'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        {
                          value: FilterMatchMode.NOT_CONTAINS,
                          label: "Not Contains",
                        },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      headerStyle={{
                        width: frozenColumnWidths.filingName,
                        minWidth: frozenColumnWidths.filingName,
                        maxWidth: frozenColumnWidths.filingName,
                      }}
                      style={{
                        width: frozenColumnWidths.filingName,
                        minWidth: frozenColumnWidths.filingName,
                        maxWidth: frozenColumnWidths.filingName,
                      }}
                      body={(rowData) => cellListDisplayName(rowData)}
                    ></Column>
                    {/* <Column
                {/* <Column
                  field='filingDescription'
                  header='Filing Description'
                 sortable
                  filter
                  filterPlaceholder='Search by Description'
                  style={{ minWidth: "25rem" }}
                ></Column> */}
                    <Column
                      field='filingFrequency'
                      header='Filing Frequency'
                      filter
                      className='frozen-filing-frequency-col'
                      headerClassName='frozen-filing-frequency-col'
                      frozen={enableForzen}

                      filterPlaceholder='Search by Frequency'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        {
                          value: FilterMatchMode.NOT_CONTAINS,
                          label: "Not Contains",
                        },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      headerStyle={{
                        width: frozenColumnWidths.filingFrequency,
                        minWidth: frozenColumnWidths.filingFrequency,
                        maxWidth: frozenColumnWidths.filingFrequency,
                      }}
                      style={{
                        width: frozenColumnWidths.filingFrequency,
                        minWidth: frozenColumnWidths.filingFrequency,
                        maxWidth: frozenColumnWidths.filingFrequency,
                      }}
                    ></Column>
                    <Column
                      field='dueDate'
                      header='Due Date'
                      dataType='date'
                      filter
                      className='frozen-due-date-col'
                      headerClassName='frozen-due-date-col'
                      frozen={enableForzen}

                      filterField='dueDate'
                      filterPlaceholder='Search by Due Date'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterElement={dateFilterTemplate}
                      editor={(options) => cellEditor(options)}
                      headerStyle={{
                        width: frozenColumnWidths.dueDate,
                        minWidth: frozenColumnWidths.dueDate,
                        maxWidth: frozenColumnWidths.dueDate,
                      }}
                      style={{
                        width: frozenColumnWidths.dueDate,
                        minWidth: frozenColumnWidths.dueDate,
                        maxWidth: frozenColumnWidths.dueDate,
                      }}
                      sortable
                      body={cellListDisplayDueDate}
                    ></Column>
                    <Column
                      field='stateList'
                      header='State'
                      sortable
                      filter
                      filterField='stateList'
                      filterPlaceholder='Search by State'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      filterMenuStyle={{ width: "15rem" }}
                      filterElement={stateRowFilterTemplate}
                      onFilterMatchModeChange={() => setMasterCatFilter([])}
                      onFilterClear={() => setMasterCatFilter([])}
                      style={{ minWidth: "13rem" }}
                      className='column-small'
                    ></Column>
                    <Column
                      field='ruleInfo'
                      header='Rule Info'
                      filter
                      filterPlaceholder='Search by Rule Info'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        {
                          value: FilterMatchMode.NOT_CONTAINS,
                          label: "Not Contains",
                        },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      style={{ minWidth: "15rem", maxWidth: "15rem" }}
                      body={(rowData) => cellListDisplayRuleInfo(rowData)}
                    ></Column>
                    <Column
                      field='required'
                      header='Required?'
                      filter
                      filterField="required"
                      filterElement={requiredRowFilterTemplate}
                      onFilterClear={() => setMasterCatFilter([])}
                      showFilterMatchModes={false}
                      style={{ minWidth: "13rem" }}
                      className='column-small'
                      filterPlaceholder='Search by Required'
                      showAddButton={false}
                      showFilterOperator={false}
                    ></Column>
                    <Column
                      field='federalCategories'
                      header='Who Must File Federal'
                      className='expandableColumn-fm'
                      // sortable
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "federalCategories")
                      }
                      filter
                      filterField='federalCategories'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.IN, label: "Contains" },
                        { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      onFilterMatchModeChange={() => setMasterCatFilter([])}
                      filterPlaceholder='Search by Cateogry'
                      filterElement={(options) =>
                        masterCategoryFilter(options, "federalCategories")
                      }
                      onFilterClear={() => setMasterCatFilter([])}
                      style={{ minWidth: "18rem", maxWidth: "18rem" }}
                    //showFilterMenu={false}
                    //filterMenuStyle={{ width: "14rem" }}
                    //  showClearButton={false}
                    // filterFunction={customCategoryFilter}
                    ></Column>
                    <Column
                      field='stateCategories'
                      header='Who Must File in State'
                      className='expandableColumn-fm'
                      // sortable
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "stateCategories")
                      }
                      filter
                      filterField='stateCategories'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.IN, label: "Contains" },
                        { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      onFilterMatchModeChange={() => setMasterCatFilter([])}
                      filterPlaceholder='Search by Cateogry'
                      filterElement={(options) =>
                        masterCategoryFilter(options, "stateCategories")
                      }
                      onFilterClear={() => setMasterCatFilter([])}
                      style={{ minWidth: "18rem", maxWidth: "18rem" }}
                    //showFilterMenu={false}
                    //filterMenuStyle={{ width: "14rem" }}
                    //  showClearButton={false}
                    ></Column>
                    {/* <Column
                  field='jsidept'
                  header='JSI Dept'
                  filter
                  filterPlaceholder='Search by dept'
                  style={{ minWidth: "20rem" }}
                ></Column> */}
                    <Column
                      field='jsicontactName'
                      header='JSI Staff'
                      filter
                      filterPlaceholder='Search by JSI Staff'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        {
                          value: FilterMatchMode.NOT_CONTAINS,
                          label: "Not Contains",
                        },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      style={{ minWidth: "12rem" }}
                    ></Column>
                    {/* <Column
                  field='jsicontactEmail'
                  header='JSI Contact Email'
                  filter
                  filterPlaceholder='Search by contactEmail'
                  style={{ minWidth: "20rem" }}
                ></Column> */}
                    <Column
                      field='juristiction'
                      header='Jurisdiction'
                      sortable
                      filterField='juristiction'
                      showAddButton={false}
                      showFilterOperator={false}
                      showFilterMatchModes={false}
                      //showFilterMenu={false}
                      // filterMenuStyle={{ width: "10rem" }}
                      style={{ minWidth: "10rem" }}
                      filter
                      filterElement={jurisdictionRowFilterTemplate}
                      onFilterClear={() => setMasterCatFilter([])}
                      onFilterMatchModeChange={() => setMasterCatFilter([])}
                    ></Column>
                    <Column
                      field='whereToFile'
                      header='Where to File'
                      filter
                      body={(rowData) => cellListDisplayWhereToFile(rowData)}
                      filterPlaceholder='Search by Where To File'
                      showAddButton={false}
                      showFilterOperator={false}
                      filterMatchModeOptions={[
                        { value: FilterMatchMode.CONTAINS, label: "Contains" },
                        {
                          value: FilterMatchMode.NOT_CONTAINS,
                          label: "Not Contains",
                        },
                        { value: FilterMatchMode.EQUALS, label: "Equal" },
                      ]}
                      filterMenuStyle={{ width: "10rem" }}
                      style={{ minWidth: "13rem", maxWidth: "13rem" }}
                    ></Column>
                    <Column
                      field='notes'
                      header='Notes'
                      headerStyle={{ minWidth: "20rem", maxWidth: "20rem" }}
                      style={{ minWidth: "45rem", maxWidth: "45rem" }}
                      body={(rowData) => cellListDisplayNotes(rowData)}
                    ></Column>
                  </DataTable>
                )}
              </TabPanel>
              <TabPanel value='2'>
                <DataTable
                  className='frozen-filing-master'
                  key='list'
                  scrollable
                  resizableColumns
                  columnResizeMode='expand'
                  showGridlines
                  value={filingMasters}
                  selection={selectedmasters}
                  onSelectionChange={(e) => setSelectedMasters(e.value)}
                  dataKey='masterId'
                  onRowSelect={onRowSelect}
                  loading={isLoading}
                  // onRowToggle={(e) => rowExpand(e)}
                  // rowExpansionTemplate={rowExpansionTemplate}
                  // expandedRows={expandedRows}
                  // paginator
                  // rows={10}
                  // rowsPerPageOptions={[5, 10, 25, 50]}
                  style={{ width: "100%", minWidth: "100%", borderRadius: "8px", overflow: "hidden", border: "none", background: tokens.colors.offWhite }}
                  filters={filters}
                  // filterDisplay="row"
                  globalFilterFields={["filingName"]}
                  header={header}
                  ref={historyTableRef}
                  virtualScrollerOptions={{
                    // lazy: true,
                    onScroll: loadDataLazy,
                    itemSize: 45,
                    delay: 0,
                    scrollHeight: "550px",
                    appendOnly: true,
                    // showLoader: true,
                    // loading: lazyLoading,
                    // loadingTemplate,
                  }}
                  scrollHeight="550px"
                  onFilter={(e) => onFilterChange(e)}
                  sortField={sortingData.sortBy}
                  sortOrder={sortingData.sortOrder}
                  onSort={(e) => handleSort(e)}
                >
                  {/* <Column expander={true} style={{ width: "5rem" }} /> */}
                  <Column
                    selectionMode='single'
                    headerStyle={{ width: "50px", minWidth: "50px", maxWidth: "50px" }}
                    style={{ width: "50px", minWidth: "50px", maxWidth: "50px", margin: "0", textAlign: "center" }}
                  >
                    Select
                  </Column>
                  {/* <Column
                  headerStyle={{ width: "2rem" }}
                  // header="Attachemts"
                  body={(rowData) => <FilingCommentButton rowData={rowData} />}
                ></Column>
                <Column
                  headerStyle={{ width: "2rem" }}
                  // header="Attachemts"
                  body={(rowData) => (
                    <FilingAttachmentButton rowData={rowData} />
                  )}
                ></Column> */}
                  <Column
                    header='Indicators'
                    headerStyle={{ width: "90px", minWidth: "90px", maxWidth: "90px" }}
                    style={{ width: "90px", minWidth: "90px", maxWidth: "90px", textAlign: "center" }}
                    body={(rowData) => (
                      <>
                        <Stack direction='row'>
                          <FilingCommentButton rowData={rowData} />

                          <FilingAttachmentButton rowData={rowData} />
                        </Stack>
                      </>
                    )}
                  ></Column>
                  <Column
                    field='filingName'
                    header='Filing Name'
                    sortable
                    filter
                    frozen={enableForzen}

                    className='filingNameColumn-fm frozen-filing-name-col'
                    headerClassName='frozen-filing-name-col'
                    filterPlaceholder='Search by Filing Name'
                    showAddButton={false}
                    showFilterOperator={false}
                    filterMatchModeOptions={[
                      { value: FilterMatchMode.CONTAINS, label: "Contains" },
                      {
                        value: FilterMatchMode.NOT_CONTAINS,
                        label: "Not Contains",
                      },
                      { value: FilterMatchMode.EQUALS, label: "Equal" },
                    ]}
                    headerStyle={{
                      width: frozenColumnWidths.filingName,
                      minWidth: frozenColumnWidths.filingName,
                      maxWidth: frozenColumnWidths.filingName,
                    }}
                    style={{
                      width: frozenColumnWidths.filingName,
                      minWidth: frozenColumnWidths.filingName,
                      maxWidth: frozenColumnWidths.filingName,
                    }}
                    body={(rowData) => cellListDisplayName(rowData)}
                  ></Column>
                  {/* <Column
                {/* <Column
                  field='filingDescription'
                  header='Filing Description'
                 sortable
                  filter
                  filterPlaceholder='Search by Description'
                  style={{ minWidth: "25rem" }}
                ></Column> */}
                  <Column
                    field='filingFrequency'
                    header='Filing Frequency'
                    filter
                    className='frozen-filing-frequency-col'
                    headerClassName='frozen-filing-frequency-col'
                    frozen={enableForzen}
                    filterPlaceholder='Search by Frequency'
                    showAddButton={false}
                    showFilterOperator={false}
                    filterMatchModeOptions={[
                      { value: FilterMatchMode.CONTAINS, label: "Contains" },
                      {
                        value: FilterMatchMode.NOT_CONTAINS,
                        label: "Not Contains",
                      },
                      { value: FilterMatchMode.EQUALS, label: "Equal" },
                    ]}
                    headerStyle={{
                      width: frozenColumnWidths.filingFrequency,
                      minWidth: frozenColumnWidths.filingFrequency,
                      maxWidth: frozenColumnWidths.filingFrequency,
                    }}
                    style={{
                      width: frozenColumnWidths.filingFrequency,
                      minWidth: frozenColumnWidths.filingFrequency,
                      maxWidth: frozenColumnWidths.filingFrequency,
                    }}
                  ></Column>
                  <Column
                    field='dueDate'
                    header='Due Date'
                    dataType='date'
                    filter
                    className='frozen-due-date-col'
                    headerClassName='frozen-due-date-col'
                    frozen={enableForzen}
                    filterField='dueDate'
                    filterPlaceholder='Search by Due Date'
                    showAddButton={false}
                    showFilterOperator={false}
                    filterElement={dateFilterTemplate}
                    editor={(options) => cellEditor(options)}
                    headerStyle={{
                      width: frozenColumnWidths.dueDate,
                      minWidth: frozenColumnWidths.dueDate,
                      maxWidth: frozenColumnWidths.dueDate,
                    }}
                    style={{
                      width: frozenColumnWidths.dueDate,
                      minWidth: frozenColumnWidths.dueDate,
                      maxWidth: frozenColumnWidths.dueDate,
                    }}
                    sortable
                    body={cellListDisplayDueDate}
                  ></Column>
                  <Column
                    field='stateList'
                    header='State'
                    sortable
                    filter
                    filterField='stateList'
                    filterPlaceholder='Search by State'
                    showAddButton={false}
                    showFilterOperator={false}
                    filterMatchModeOptions={[
                      { value: FilterMatchMode.CONTAINS, label: "Contains" },
                      { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                      { value: FilterMatchMode.EQUALS, label: "Equal" },
                    ]}
                    filterMenuStyle={{ width: "15rem" }}
                    filterElement={stateRowFilterTemplate}
                    onFilterMatchModeChange={() => setMasterCatFilter([])}
                    onFilterClear={() => setMasterCatFilter([])}
                    style={{ minWidth: "13rem" }}
                    className='column-small'
                  ></Column>
                  <Column
                    field='ruleInfo'
                    header='Rule Info'
                    filter
                    filterPlaceholder='Search by Rule Info'
                    showAddButton={false}
                    showFilterOperator={false}
                    filterMatchModeOptions={[
                      { value: FilterMatchMode.CONTAINS, label: "Contains" },
                      {
                        value: FilterMatchMode.NOT_CONTAINS,
                        label: "Not Contains",
                      },
                      { value: FilterMatchMode.EQUALS, label: "Equal" },
                    ]}
                    style={{ minWidth: "15rem", maxWidth: "15rem" }}
                    body={(rowData) => cellListDisplayRuleInfo(rowData)}
                  ></Column>
                  <Column
                    field='required'
                    header='Required?'
                    filter
                    style={{ minWidth: "13rem" }}
                    className='column-small'
                    filterPlaceholder='Search by Required'
                    showAddButton={false}
                    showFilterOperator={false}
                    showFilterMatchModes={false}
                    filterElement={requiredRowFilterTemplate}
                    onFilterClear={() => setMasterCatFilter([])}
                  ></Column>
                  <Column
                    field='federalCategories'
                    header='Who Must File Federal'
                    className='expandableColumn-fm'
                    // sortable
                    body={(rowData) =>
                      CellListDisplayFederal(rowData, "federalCategories")
                    }
                    filter
                    filterField='federalCategories'
                    showAddButton={false}
                    showFilterOperator={false}
                    filterMatchModeOptions={[
                      { value: FilterMatchMode.IN, label: "Contains" },
                      { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                      { value: FilterMatchMode.EQUALS, label: "Equal" },
                    ]}
                    onFilterMatchModeChange={() => setMasterCatFilter([])}
                    filterPlaceholder='Search by Cateogry'
                    filterElement={(options) =>
                      masterCategoryFilter(options, "federalCategories")
                    }
                    onFilterClear={() => setMasterCatFilter([])}
                    style={{ minWidth: "18rem", maxWidth: "18rem" }}
                  //showFilterMenu={false}
                  //filterMenuStyle={{ width: "14rem" }}
                  //  showClearButton={false}
                  // filterFunction={customCategoryFilter}
                  ></Column>
                  <Column
                    field='stateCategories'
                    header='Who Must File in State'
                    className='expandableColumn-fm'
                    // sortable
                    body={(rowData) =>
                      CellListDisplayFederal(rowData, "stateCategories")
                    }
                    filter
                    filterField='stateCategories'
                    showAddButton={false}
                    showFilterOperator={false}
                    filterMatchModeOptions={[
                      { value: FilterMatchMode.IN, label: "Contains" },
                      { value: FilterMatchMode.NOT_CONTAINS, label: "Not Contains" },
                      { value: FilterMatchMode.EQUALS, label: "Equal" },
                    ]}
                    onFilterMatchModeChange={() => setMasterCatFilter([])}
                    filterPlaceholder='Search by Cateogry'
                    filterElement={(options) =>
                      masterCategoryFilter(options, "stateCategories")
                    }
                    onFilterClear={() => setMasterCatFilter([])}
                    style={{ minWidth: "18rem", maxWidth: "18rem" }}
                  //showFilterMenu={false}
                  //filterMenuStyle={{ width: "14rem" }}
                  //  showClearButton={false}
                  ></Column>
                  {/* <Column
                  field='jsidept'
                  header='JSI Dept'
                  filter
                  filterPlaceholder='Search by dept'
                  style={{ minWidth: "20rem" }}
                ></Column> */}
                  <Column
                    field='jsicontactName'
                    header='JSI Staff'
                    filter
                    filterPlaceholder='Search by JSI Staff'
                    showAddButton={false}
                    showFilterOperator={false}
                    filterMatchModeOptions={[
                      { value: FilterMatchMode.CONTAINS, label: "Contains" },
                      {
                        value: FilterMatchMode.NOT_CONTAINS,
                        label: "Not Contains",
                      },
                      { value: FilterMatchMode.EQUALS, label: "Equal" },
                    ]}
                    style={{ minWidth: "12rem" }}
                  ></Column>
                  {/* <Column
                  field='jsicontactEmail'
                  header='JSI Contact Email'
                  filter
                  filterPlaceholder='Search by contactEmail'
                  style={{ minWidth: "20rem" }}
                ></Column> */}
                  <Column
                    field='juristiction'
                    header='Jurisdiction'
                    sortable
                    filterField='juristiction'
                    showAddButton={false}
                    showFilterOperator={false}
                    showFilterMatchModes={false}
                    //showFilterMenu={false}
                    // filterMenuStyle={{ width: "10rem" }}
                    style={{ minWidth: "10rem" }}
                    filter
                    filterElement={jurisdictionRowFilterTemplate}
                    onFilterClear={() => setMasterCatFilter([])}
                    onFilterMatchModeChange={() => setMasterCatFilter([])}
                  ></Column>
                  <Column
                    field='whereToFile'
                    header='Where to File'
                    filter
                    body={(rowData) => cellListDisplayWhereToFile(rowData)}
                    filterPlaceholder='Search by Where To File'
                    showAddButton={false}
                    showFilterOperator={false}
                    filterMatchModeOptions={[
                      { value: FilterMatchMode.CONTAINS, label: "Contains" },
                      {
                        value: FilterMatchMode.NOT_CONTAINS,
                        label: "Not Contains",
                      },
                      { value: FilterMatchMode.EQUALS, label: "Equal" },
                    ]}
                    filterMenuStyle={{ width: "10rem" }}
                    style={{ minWidth: "13rem", maxWidth: "13rem" }}
                  ></Column>
                  <Column
                    field='notes'
                    header='Notes'
                    headerStyle={{ minWidth: "20rem", maxWidth: "20rem" }}
                    style={{ minWidth: "45rem", maxWidth: "45rem" }}
                    body={(rowData) => cellListDisplayNotes(rowData)}
                  ></Column>
                </DataTable>
              </TabPanel>
            </TabContext>

            {lazyLoading && !isLoading && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "44px",
                  height: "44px",
                  borderRadius: "50%",
                  border: "4px solid rgba(67, 37, 104, 0.22)",
                  borderTop: `4px solid ${primaryColor}`,
                  animation: "fmLazySpin 0.8s linear infinite",
                  pointerEvents: "none",
                  zIndex: 10,
                }}
                aria-label='Loading more records'
              />
            )}

          </div>
        </Box>
        <Paper
          elevation={3}
          sx={{
            width: "48px",
            borderRadius: "50px",
            py: 2,
            px: 0.5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1.5,
            position: "sticky",
            top: 100,
            backgroundColor: "#ffffff",
          }}
        >
          <Toolbox
            isLoading={isLoading}
            addComment={addComment}
            draft={selectedmasters?.customer[0]?.customerId}
            editMasterFilling={editMasterFilling}
            deleteMasterRecord={handleDelete}
            displayAttachments={displayAttachments}
            displayHistory={displayHistory}
            displayClients={displayClients}
            downloadData={exportExcel}
            downloadDataHistory={exportExcelHistory}
            isTabValue={value === "2" ? true : false}
            downloadProgress={downloadProgress}
            downloadStatusMsg={downloadStatusMsg}
            isDownloading={showDownloadProgress}
          />
        </Paper>
      </Box>
      <CustomDialog
        header={alertConfig.header}
        visible={showAlert}
        onHide={() => closeAlert()}
        icon={alertConfig.icon}
      >
        {alertMessage}
      </CustomDialog>
      <style>{`
              @keyframes fmLazySpin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
      <ConfirmDialog />
      <FilingMasterTableFilter
        anchorEl={filterAnchorEl}
        onClose={() => setFilterAnchorEl(null)}
        onApply={applyNewFilter}
        onClear={clearAllFilters}
        masters={masters}
        categoryList={categoryList}
        stateList={stateArray}
        key={`${value}-${activeFilters.length}`}
      />
      {
        <FilingMasterComments
          show={showComments}
          dockAt='right'
          draft={selectedmasters}
          comments={comments}
          handleClose={closeComments}
          refreshTable={handleRrefreshList}
          refreshTableUpcomingDueDates={upcomingDueDates}
        />
      }
      {
        <FilingMasterAttachment
          show={showAttachments}
          dockAt='right'
          tracker={selectedmasters}
          attachments={attachments}
          handleClose={closeAttachments}
        />
      }
      {
        <FilingMasterHistory
          show={showHistory}
          dockAt='right'
          tracker={selectedmasters}
          activityHistory={activityHistory}
          commentActivityHistory={commentActivityHistory}
          handleClose={closeHistory}
        />
      }
      {
        <AssociatedClient
          show={showClient}
          dockAt='right'
          draft={selectedmasters}
          clients={clients}
          handleClose={closeClient}
        />
      }
      <style>
        {`
            .header-checkbox {
              color: white !important;
              background-color: ${tokens.colors.offWhite} !important;
            }
            .header-checkbox.Mui-checked {
              color: ${primaryColor} !important;
              background-color: ${tokens.colors.offWhite} !important;
            }
            .header-checkbox svg {
              fill: white;
            }
            .p-datatable.frozen-filing-master {
              border-radius: 8px !important;
              overflow: hidden !important;
              border: none !important;
              box-shadow: none !important;
              background: ${tokens.colors.offWhite} !important;
            }
            .frozen-filing-master .p-datatable-wrapper {
              border-radius: 8px !important;
              overflow: hidden;
              background: ${tokens.colors.offWhite} !important;
            }
            .frozen-filing-master .p-datatable-header {
              background: ${tokens.colors.offWhite} !important;
              border: none !important;
              padding: 0 !important;
              margin: 0 !important;
            }
            .frozen-filing-master .p-datatable-table {
              border-radius: 8px !important;
              border-collapse: separate !important;
              border-spacing: 0 !important;
            }
            .frozen-filing-master .p-datatable-thead > tr {
              background: ${primaryColor} !important;            }
            .frozen-filing-master .p-datatable-thead > tr:first-child > th:first-child {
              border-top-left-radius: 8px !important;
            }
            .frozen-filing-master .p-datatable-thead > tr:first-child > th:last-child {
              border-top-right-radius: 8px !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr:last-child > td:first-child {
              border-bottom-left-radius: 8px !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr:last-child > td:last-child {
              border-bottom-right-radius: 8px !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr {
              height: 45px !important;
            }
            .frozen-filing-master .p-datatable-thead > tr > th {
              background: transparent !important;
              color: #ffffff !important;
              font-weight: 600 !important;
              font-size: 13px !important;
              letter-spacing: 0.02em !important;
              padding: 12px 16px !important;
              border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
              border-bottom: none !important;
              text-transform: none !important;
              box-shadow: none !important;
            }
            .frozen-filing-master .p-datatable-thead > tr > th:last-child {
              border-right: none !important;
            }
            .frozen-filing-master .p-datatable-thead > tr > th.p-frozen-column {
              background: ${primaryColor} !important;
              z-index: 2 !important;
              will-change: auto !important;
              transition: left 220ms ease, width 220ms ease, min-width 220ms ease, max-width 220ms ease !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr > td.p-frozen-column {
              background: ${tokens.colors.offWhite} !important;
              color: #000000 !important;
              z-index: 1 !important;
              will-change: auto !important;
              transition: left 220ms ease, width 220ms ease, min-width 220ms ease, max-width 220ms ease !important;
            }
            .frozen-filing-master .p-sortable-column-icon {
              color: #ffffff !important;
            }
            .frozen-filing-master .p-selection-column,
            .frozen-filing-master .p-datatable-tbody > tr > td.p-selection-column {
              text-align: center !important;
            }
            .frozen-filing-master .p-selection-column .p-radiobutton {
              margin: 0 auto !important;
              display: inline-flex !important;
            }
            .frozen-filing-master .p-selection-column .p-radiobutton .p-radiobutton-box {
              border: 2px solid ${primaryColor} !important;
            }
            .frozen-filing-master .p-selection-column .p-radiobutton .p-radiobutton-box.p-highlight {
              border-color: ${primaryColor} !important;
              background: ${primaryColor} !important;
            }
            .frozen-filing-master .p-selection-column .p-radiobutton:not(.p-radiobutton-disabled) .p-radiobutton-box:hover {
              border-color: ${primaryColor} !important;
            }
            .frozen-filing-master .p-datatable-thead > tr > th.frozen-filing-name-col.p-frozen-column,
            .frozen-filing-master .p-datatable-tbody > tr > td.frozen-filing-name-col.p-frozen-column {
              left: 0 !important;
            }
            .frozen-filing-master .p-datatable-thead > tr > th.frozen-filing-frequency-col.p-frozen-column,
.frozen-filing-master .p-datatable-tbody > tr > td.frozen-filing-frequency-col.p-frozen-column {
  left: 15.7rem !important;
}
            .frozen-filing-master .p-datatable-thead > tr > th.frozen-due-date-col.p-frozen-column,
.frozen-filing-master .p-datatable-tbody > tr > td.frozen-due-date-col.p-frozen-column {
  left: 25.7rem !important;
}
            .p-datatable.frozen-filing-master.frozen-filing-master--scrolled .p-datatable-thead > tr > th.frozen-filing-frequency-col.p-frozen-column,
            .p-datatable.frozen-filing-master.frozen-filing-master--scrolled .p-datatable-tbody > tr > td.frozen-filing-frequency-col.p-frozen-column {
              left: 250px !important;
            }
            .p-datatable.frozen-filing-master.frozen-filing-master--scrolled .p-datatable-thead > tr > th.frozen-due-date-col.p-frozen-column,
            .p-datatable.frozen-filing-master.frozen-filing-master--scrolled .p-datatable-tbody > tr > td.frozen-due-date-col.p-frozen-column {
              left: 410px !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr > td {
              background-color: ${tokens.colors.offWhite} !important;
              padding: 0 12px !important;
              font-size: 15px !important;
              line-height: 1.2 !important;
              color: #000000 !important;
              overflow: hidden !important;
              text-overflow: ellipsis !important;
              white-space: nowrap !important;
              border-right: 1px solid ${primaryColor} !important;
              border-bottom: 1px solid ${primaryColor} !important;
              border-left: none !important;
              border-top: none !important;
              vertical-align: middle !important;
              height: 45px !important;
              min-height: 45px !important;
              max-height: 45px !important;
              box-sizing: border-box !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr:nth-child(odd) > td {
              background-color: #ffffff !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr:nth-child(even) > td {
              background-color: ${tokens.colors.offWhite} !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column {
              background: #ffffff !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column {
              background: ${tokens.colors.offWhite} !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr > td:last-child {
              border-right: none !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr > td.filingNameColumn-fm:hover,
            .frozen-filing-master .p-datatable-tbody > tr > td.expandableColumn-fm:hover {
              background-color: color-mix(in srgb, ${tableHeaderColor} 8%, white) !important;
              cursor: pointer !important;
              transition: background-color 0.2s ease;
              border-right: 1px solid ${tableHeaderColor} !important;
              border-bottom: 1px solid ${tableHeaderColor} !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr > td.filingNameColumn-fm:hover *,
            .frozen-filing-master .p-datatable-tbody > tr > td.expandableColumn-fm:hover * {
              font-weight: 600 !important;
              color: ${tableHeaderColor} !important;
            }
            .frozen-filing-master .p-datatable-tbody > tr.p-highlight > td,
            .frozen-filing-master .p-datatable-tbody > tr.p-highlight > td.p-frozen-column {
              background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
              border-right: 1px solid ${tableHeaderColor} !important;
              border-bottom: 1px solid ${tableHeaderColor} !important;
            }
            .frozen-filing-master .p-column-filter-menu-button,
            .frozen-filing-master .p-column-filter-clear-button,
            .frozen-filing-master .p-column-filter-row {
              display: none !important;
            }
            .frozen-filing-master .p-datatable-loading-overlay {
              background: rgba(0, 0, 0, 0.35) !important;
              backdrop-filter: none !important;
              -webkit-backdrop-filter: none !important;
            }
            .frozen-filing-master .p-datatable-loading-icon {
              color: ${primaryColor} !important;
              font-size: 2rem !important;
              opacity: 0.95;
              text-rendering: geometricPrecision;
              -webkit-font-smoothing: antialiased;
            }
            .frozen-filing-master .p-datatable-loading-icon.pi-spin {
              animation-duration: 0.7s !important;
            }
            .filing-master-overlay-panel {
              z-index: 1100 !important;
              width: min(22rem, calc(100vw - 1rem)) !important;
              max-width: min(22rem, calc(100vw - 1rem)) !important;
              max-height: min(18rem, calc(100vh - 1rem)) !important;
              background: ${tokens.colors.offWhite} !important;
              border: 1px solid #C0BEC2 !important;
              overflow: visible !important;
              box-sizing: border-box !important;
            }
            .filing-master-overlay-panel .p-overlaypanel-content {
              padding: 1.5rem 1rem 1rem 1rem !important;
              background: ${tokens.colors.offWhite} !important;
              max-width: 100% !important;
              box-sizing: border-box !important;
            }
            .filing-master-overlay-panel .p-scrollpanel,
            .filing-master-overlay-panel .p-scrollpanel-wrapper,
            .filing-master-overlay-panel .p-scrollpanel-content {
              width: 100% !important;
              max-width: 100% !important;
              box-sizing: border-box !important;
            }
            .filing-master-overlay-panel ul {
              overflow-wrap: anywhere;
              white-space: normal;
            }
            .filing-master-overlay-panel .p-overlaypanel-close {
              background: ${primaryColor} !important;
              border: none !important;
              border-radius: 999px !important;
              width: 1.6rem !important;
              height: 1.6rem !important;
              color: #ffffff !important;
              position: absolute !important;
              top: 0.35rem !important;
              right: 0.35rem !important;
              margin: 0 !important;
              z-index: 2 !important;
              display: inline-flex !important;
              align-items: center !important;
              justify-content: center !important;
            }
            .filing-master-overlay-panel .p-overlaypanel-close:hover {
              background: ${primaryColor} !important;
              filter: brightness(1.08);
            }
            .filing-master-overlay-panel .p-overlaypanel-close .p-overlaypanel-close-icon {
              color: #ffffff !important;
            }
            .p-datatable-wrapper::-webkit-scrollbar {
              width: 8px;
              height: 8px;
            }
            .p-datatable-wrapper::-webkit-scrollbar-thumb {
              background: #c0bec2;
              border-radius: 10px;
            }
            .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
              background: ${primaryColor};
            }
          `}</style>
    </Box >

  );
};

export default FilingMasterList;

